<template>
    <div>
        <Fieldset :legend="$t('searchHeader')" :toggleable="true">
            <div class="p-fluid p-mt-2 p-ml-3 p-mr-3 p-mb-2" @keyup.enter="saveData_Modal('search')">
                <div class="p-formgrid p-grid p-col">
                    <div class="p-col-12 p-lg-6 p-mt-2">
                        <div class="p-formgrid p-grid">
                            <div class="p-field p-col-10 p-lg-10">
                                <label class="p-mr-2">หน่วยงานที่รับผิดชอบ</label>
                                <Button
                                    @click="
                                        showOrganize = true;
                                        setOpenModal_OrganizeMulti = 'search';
                                    "
                                    icon="pi pi-plus"
                                    class="p-button-success"
                                    ref="TextBox_1_search"
                                    @keyup.left="moveFocus($event, 'TextBox_6_search', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_2_search', 'Input')"
                                    @keyup.down="moveFocus($event, 'TextBox_5_search', 'Input')"
                                />
                            </div>
                        </div>
                        <div class="p-field p-col p-mt-2" style="margin-left: -10px">
                            <DataTable
                                :value="organize_table"
                                :scrollable="true"
                                scrollHeight="500px"
                                :paginator="true"
                                :rows="3"
                                dataKey="id"
                                :rowHover="true"
                                :selection.sync="selectedOrganizeData"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
                            >
                                <template #empty>{{ $t('TableEmpty') }}</template>
                                <Column field="organize_name" :header="$t('id_operating_name')" :sortable="true" headerStyle="width: 20rem">
                                    <template #body="dataTable">
                                        <div hidden>{{ dataTable.data.organize_id }}</div>
                                        {{ dataTable.data.organize_name }}
                                    </template>
                                </Column>
                                <Column :header="$t('controlTable')" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        <div class="p-formgrid p-grid">
                                            <div class="p-field p-col-6">
                                                <Button
                                                    @click="
                                                        // displayConfirmation = true;
                                                        deleteAt = 'organize';
                                                        organizeDelete = dataTable.data;
                                                        alertDisplay(organizeDelete, deleteAt);
                                                    "
                                                    icon="pi pi-trash"
                                                    :label="$t('deleteBtn')"
                                                    class="p-button-rounded p-button-danger"
                                                />
                                            </div>
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                    </div>

                    <div class="p-col p-mt-3 p-ml-3">
                        <div class="p-field p-col-12 p-lg-12 p-mt-2">
                            <label for="prevent_name">{{ $t('idp_prevent_name') }}</label>
                            <InputText
                                id="prevent_name"
                                type="text"
                                v-model="prevent_name"
                                ref="TextBox_2_search"
                                @keyup.left="moveFocus($event, 'TextBox_1_search', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_3_search', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_3_search', 'Input')"
                            />
                        </div>

                        <div class="p-grid p-col p-mt-2">
                            <div class="p-field p-col-12 p-lg-6 p-mt-2">
                                <label for="prevent_type">{{ $t('idp_prevent_type') }}</label>
                                <Dropdown
                                    v-model="preventTypeSelect"
                                    :options="preventTypeOptions"
                                    optionLabel="system_name"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :showClear="true"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="preventTypeOptions">
                                        <div v-if="preventTypeOptions.value">
                                            <div>{{ preventTypeOptions.value.system_name }}</div>
                                        </div>
                                        <span v-else>
                                            {{ preventTypeOptions.placeholder }}
                                        </span>
                                    </template>
                                    <template #option="preventTypeOptions">
                                        <div>{{ preventTypeOptions.option.system_name }}</div>
                                    </template>
                                </Dropdown>
                            </div>

                            <div class="p-field p-col-12 p-lg-6 p-mt-2">
                                <label for="disaster_type">{{ $t('disaster_type') }}</label>
                                <Dropdown
                                    v-model="disasterTypeSelected"
                                    :options="disasterTypeOptions"
                                    optionLabel="system_name"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :showClear="true"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="disasterTypeOptions">
                                        <div v-if="disasterTypeOptions.value">
                                            <div>{{ disasterTypeOptions.value.system_name }}</div>
                                        </div>
                                        <span v-else>
                                            {{ disasterTypeOptions.placeholder }}
                                        </span>
                                    </template>
                                    <template #option="disasterTypeOptions">
                                        <div class="EV_disasterOptions">{{ disasterTypeOptions.option.system_name }}</div>
                                    </template>
                                </Dropdown>
                            </div>
                        </div>

                        <div class="p-formgrid p-grid p-col p-mt-1">
                            <div class="p-field p-col-12 p-lg-4 p-mt-2">
                                <label for="provinceOptions">{{ $t('province') }}</label>
                                <Dropdown
                                    v-model="selectedProvince"
                                    :options="provinceOptions"
                                    optionLabel="province_name"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :showClear="true"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="provinceOptions">
                                        <div v-if="provinceOptions.value">
                                            <div>{{ provinceOptions.value.province_name }}</div>
                                        </div>
                                    </template>
                                    <template #option="provinceOptions">
                                        <div>{{ provinceOptions.option.province_name }}</div>
                                    </template>
                                </Dropdown>
                            </div>

                            <div class="p-field p-col-12 p-lg-4 p-mt-2">
                                <label for="amphurOptions">{{ $t('amphur') }}</label>
                                <Dropdown
                                    :disabled="isDisabledAmphur == 1"
                                    v-model="selectedAmphur"
                                    :options="amphurOptions"
                                    optionLabel="amphur_name"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :showClear="true"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="amphurOptions">
                                        <div v-if="amphurOptions.value">
                                            <div>{{ amphurOptions.value.amphur_name }}</div>
                                        </div>
                                    </template>
                                    <template #option="amphurOptions">
                                        <div>{{ amphurOptions.option.amphur_name }}</div>
                                    </template>
                                </Dropdown>
                            </div>

                            <div class="p-field p-col-12 p-lg-4 p-mt-2">
                                <label for="tambonOptions">{{ $t('tambon') }}</label>
                                <Dropdown
                                    :disabled="isDisabledTambon == 1"
                                    v-model="selectedTambon"
                                    :options="tambonOptions"
                                    optionLabel="tambon_name"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :showClear="true"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="tambonOptions">
                                        <div v-if="tambonOptions.value">
                                            <div>{{ tambonOptions.value.tambon_name }}</div>
                                        </div>
                                    </template>
                                    <template #option="tambonOptions">
                                        <div>{{ tambonOptions.option.tambon_name }}</div>
                                    </template>
                                </Dropdown>
                            </div>
                            <!-- <div class="p-field p-col-8 p-lg-3 p-mt-2">
                  <label for="organize">{{ $t("response_agency") }}</label>
                  <InputText
                    id="prevent_organize"
                    type="text"
                    v-model="selectedOrganize.name"
                    disabled
                  />
                </div>
                <div class="p-field p-lg-1 " style="padding-top: 3.5px ;" >
                  <div class="p-formgrid p-grid p-jc-start p-mt-5">
                    <Button
                      @click="showOrganize = true"
                      icon="pi pi-ellipsis-h"
                      class="p-button-secondary p-mr-2"
                    />
                    <Button
                      @click="selectedOrganize = {}"
                      icon="pi pi-times"
                      class="p-button-danger"
                    />
                  </div>
                </div> -->
                        </div>

                        <div class="p-formgrid p-grid p-col p-mt-3">
                            <div class="p-field p-col-12 p-lg-6 p-mt-2">
                                <label for="prevent_code">{{ $t('idp_code') }}</label>
                                <InputText
                                    id="prevent_code"
                                    type="text"
                                    v-model="prevent_code"
                                    ref="TextBox_3_search"
                                    @keyup.left="moveFocus($event, 'TextBox_2_search', 'Input')"
                                    @keyup.right="moveFocus($event, 'TextBox_4_search', 'Input')"
                                    @keyup.up="moveFocus($event, 'TextBox_2_search', 'Input')"
                                    @keyup.down="moveFocus($event, 'TextBox_5_search', 'Button')"
                                />
                            </div>
                            <div class="p-field p-col-12 p-lg-6 p-mt-2">
                                <label for="location">{{ $t('location') }}</label>
                                <InputText
                                    id="prevent_location"
                                    type="text"
                                    v-model="location"
                                    ref="TextBox_4_search"
                                    @keyup.left="moveFocus($event, 'TextBox_3_search', 'Input')"
                                    @keyup.right="moveFocus($event, 'TextBox_5_search', 'Button')"
                                    @keyup.up="moveFocus($event, 'TextBox_2_search', 'Input')"
                                    @keyup.down="moveFocus($event, 'TextBox_5_search', 'Button')"
                                />
                            </div>
                            <div class="p-field p-col">
                                <div class="p-formgrid p-grid p-jc-end p-mt-5">
                                    <!-- Doe โหลด โทรศัพท์ -->
                                    <Button
                                        v-if="window.width <= 430"
                                        @click="MobileClearSearchField()"
                                        :label="$t('clearBtn')"
                                        class="p-button-clear p-ml-3 p-mr-3"
                                        ref="TextBox_5_search"
                                        @keyup.left="moveFocus($event, 'TextBox_4_search', 'Input')"
                                        @keyup.right="moveFocus($event, 'TextBox_6_search', 'Button')"
                                        @keyup.up="moveFocus($event, 'TextBox_3_search', 'Input')"
                                    />
                                    <Button
                                        v-else
                                        @click="clearSearchField()"
                                        :label="$t('clearBtn')"
                                        class="p-button-clear p-ml-3 p-mr-3"
                                        ref="TextBox_5_search"
                                        @keyup.left="moveFocus($event, 'TextBox_4_search', 'Input')"
                                        @keyup.right="moveFocus($event, 'TextBox_6_search', 'Button')"
                                        @keyup.up="moveFocus($event, 'TextBox_3_search', 'Input')"
                                    />
                                    <!-- Doe โหลด โทรศัพท์ -->
                                    <Button
                                        @click="searchDisasterPreventInfo()"
                                        :label="$t('searchBtn')"
                                        class="p-button-info"
                                        ref="TextBox_6_search"
                                        @keyup.left="moveFocus($event, 'TextBox_5_search', 'Button')"
                                        @keyup.right="moveFocus($event, 'TextBox_1_search', 'Button')"
                                        @keyup.up="moveFocus($event, 'TextBox_3_search', 'Input')"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="p-formgrid p-grid p-col p-mt-1">
                    <text-footer
                        :data="Data_text_Footer"
                        :checkShow="text_Footer"
                        :countItem="disasterPreventInfo_Table.length.toLocaleString('en-US')"
                    />
                </div>
            </div>
        </Fieldset>

        <Dialog :modal="true" :header="$t('OrganizeModalHeader')" :visible.sync="showOrganize" :style="{ width: '80%' }">
            <organize-table
                @selectOrganization="selectedOrganize_passValue"
                :parentmessage="parentmessage_organize"
                :checkForm="checkSelectedOrganize(setOpenModal_OrganizeMulti)"
            ></organize-table>
        </Dialog>

        <Dialog :modal="true" :header="$t('OrganizeModalHeader')" :visible.sync="showOrganize_Form" :style="{ width: '80%' }">
            <organize-form @selectOrganization="selectedOrganize_passValue_Form"></organize-form>
        </Dialog>

        <div class="card p-fluid p-mt-2">
            <!-- Doe : เพิ่ม ลำดับ 1/4   sortField="index" :sortOrder="1" -->
            <DataTable
                :value="columns_disabled ? disasterPreventInfo_Table : []"
                scrollHeight="500px"
                :paginator="true"
                :rows="10"
                dataKey="prevent_id"
                :sortOrder="1"
                sortField="index"
                ref="dt"
                :exportFilename="`ข้อมูลระบบป้องกัน/บรรเทาสาธารณภัย-${date}`"
                :rowHover="true"
                :selection.sync="selectedDisasterPreventInfo"
                :filters="filters"
                :loading="loading"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
            >
                <!-- Doe : เพิ่ม ลำดับ 1/4   sortField="index" :sortOrder="1" จบ -->
                <template #header>
                    <div class="p-grid">
                        <div class="table-header p-col-12 p-lg-1" style="padding: 7px" id="Create" v-if="checkAdd_data != 'false'">
                            <Button @click="disasterPreventInfoModal = true" :label="$t('addBtn')" class="p-button-success" />
                        </div>
                        <!-- Doe : PDF 1/3 -->
                        <div class="table-header" style="padding: 7px" id="EX">
                            <Button @click="exportCSV()" :label="$t('exportBtn')" style="background-color: green" />
                        </div>
                        <div class="table-header" style="padding: 7px" id="PDF">
                            <SplitButton
                                label="ส่งออก PDF"
                                :model="items"
                                class="p-button-raised p-button-danger"
                                style="background-color: #f33737"
                            ></SplitButton>
                        </div>
                        <!-- Doe : PDF 1/3 จบ -->

                        <!-- Doe PDF เลือกได้  1/5   -->
                        <div class="table-header" id="TABLE_EDIT" style="padding: 7px">
                            <Button
                                @click="EditPDF()"
                                icon="pi pi-cog"
                                :label="'ตั้งค่า'"
                                style="background-color: #0288d1; border: 1px solid #0288d1"
                            />
                        </div>

                        <div
                            class="table-header"
                            id="TABLE_EDIT"
                            style="padding: 7px"
                            v-if="selectedDisasterPreventInfo && selectedDisasterPreventInfo.length > 0"
                        >
                            <Button
                                @click="updateDates()"
                                icon="pi pi-cog"
                                :label="'ปรับปรุงข้อมูล'"
                                style="background-color: #fab12f; border: 1px solid #fab12f"
                            />
                        </div>

                        <!-- Doe PDF เลือกได้  1/5 จบ  -->

                        <div class="table-header p-col-12 p-lg-3" id="Search" style="margin-left: auto">
                            <!-- <span class="p-input-icon-left">
                  <i class="pi pi-search" /><InputText
                    v-model="filters['global']"
                    :placeholder="$t('searchHeader')"
                  />
                </span> -->

                            <!-- Doe ค้นหา  1/6 -->
                            <!-- <span class="p-input-icon-left" 
                  v-if="(!prevent_name &&
                        !preventTypeSelect &&
                        !disasterTypeSelected &&
                        !selectedProvince &&
                        !selectedAmphur &&
                        !selectedTambon &&
                        !selectedOrganize.name &&
                        !prevent_code &&
                        !location )">
                  <i class="pi pi-search" />
                  <InputText
                  v-model="filter"
                  @input="initialData()"
                    :placeholder="$t('searchHeader')"
                  />
                  
                </span>
                <span class="p-input-icon-left" v-else>
                  <i class="pi pi-search" />
                  <InputText
                  v-model="filter"
                  @input="searchDisasterPreventInfo()"
                  :loading = false
                    :placeholder="$t('searchHeader')"
                  />
                </span> -->

                            <span class="p-input-icon-left" v-if="columns_disabled">
                                <i class="pi pi-search" />
                                <InputText v-model="filter" @input="search" :placeholder="$t('searchHeader')" ref="searchInput" />
                            </span>
                            <span class="p-input-icon-left" v-else>
                                <i class="pi pi-search" />
                                <InputText disabled v-model="filter" :placeholder="$t('searchHeader')" />
                            </span>

                            <!-- Doe ค้นหา  1/6 จบ-->
                        </div>
                    </div>
                </template>

                <Column :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')">
                    <template #header>
                        <div v-if="columns_disabled">
                            <input
                                style="width: 20px; height: 20px"
                                type="checkbox"
                                :checked="selectedDisasterPreventInfo.length === disasterPreventInfo_Table.length"
                                @change="onSelectAll($event.target.checked)"
                            />
                        </div>
                    </template>
                    <template #body="slotProps">
                        <div class="table_row" v-if="columns_disabled" style="text-align: center">
                            <input
                                style="width: 20px; height: 20px"
                                type="checkbox"
                                :checked="selectedDisasterPreventInfo.some((item) => item.prevent_id === slotProps.data.prevent_id)"
                                @change="onSelectRow(slotProps.data, $event.target.checked)"
                            />
                        </div>
                    </template>
                </Column>

                <template #empty>{{ $t('TableEmpty') }}</template>
                <div v-if="columns_index == true">
                    <!--Doe : เพิ่มลำดับ 2/4-->
                    <Column field="index" :header="'ลำดับ'" :sortable="true" :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_index == true">
                                {{ dataTable.data.index }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>
                <!--Doe : เพิ่มลำดับ 2/4 จบ-->

                <div v-if="columns_prevent_name == true">
                    <Column
                        field="prevent_name"
                        :header="$t('idp_prevent_name')"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_prevent_name == true">
                                {{ dataTable.data.prevent_name }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_system_name == true">
                    <Column
                        field="system_name"
                        :header="$t('idp_prevent_type')"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_system_name == true">
                                {{ dataTable.data.system_name }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_disaster_details == true">
                    <Column
                        field="disaster_details"
                        :header="$t('related_disaster')"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_disaster_details == true">
                                <div v-if="dataTable.data.disaster_id == '[]'">-</div>
                                <div v-else>
                                    <div v-for="disaster in JSON.parse(dataTable.data.disaster_id)" :key="disaster.disaster_id">
                                        {{ disaster.system_name }}
                                    </div>
                                </div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_prevent_location == true">
                    <Column
                        field="prevent_location"
                        :header="$t('location')"
                        :sortable="true"
                        :headerStyle="tableColSticky('25rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_prevent_location == true">
                                <div v-if="dataTable.data.prevent_location == ''">-</div>
                                <div v-else>{{ dataTable.data.prevent_location }}</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_prevent_contact_name == true">
                    <Column
                        field="prevent_contact_name"
                        :header="$t('contact_name')"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_prevent_contact_name == true">
                                <div v-if="dataTable.data.prevent_contact_name == ''">-</div>
                                <div v-else>{{ dataTable.data.prevent_contact_name }}</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_prevent_contact_phone == true">
                    <!-- <Column 
            field="prevent_contact_phone"
            :header="$t('contact_phone')"
            :sortable="true"
            headerStyle="width: 15rem"
          >
            <template #body="dataTable">
              <div v-if="dataTable.data.prevent_contact_phone == ''">-</div>
              <div v-else>{{ dataTable.data.prevent_contact_phone }}</div>
            </template>
          </Column> -->
                    <Column
                        field="text_tel_detail"
                        :header="$t('contact_phone')"
                        :sortable="true"
                        :headerStyle="tableColSticky('250px', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_prevent_contact_phone == true">
                                <span v-html="dataTable.data.text_tel_detailHTML"></span>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_date_create == true">
                    <Column
                        field="date_create_ddmmyy"
                        :header="'วันที่สร้างข้อมูล'"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_date_create == true">
                                {{ dataTable.data.date_create_ddmmyy }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_date_update == true">
                    <Column
                        field="date_update_ddmmyy"
                        :header="'วันที่ปรับปรุงข้อมูล'"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_date_update == true">
                                {{ dataTable.data.date_update_ddmmyy }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div
                    v-if="
                        columns_prevent_contact_phone ||
                        columns_index ||
                        columns_prevent_name ||
                        columns_system_name ||
                        columns_disaster_details ||
                        columns_prevent_location ||
                        columns_date_create ||
                        columns_date_update
                    "
                >
                    <Column
                        :header="$t('controlTable')"
                        :headerStyle="table_headerStyle"
                        :bodyStyle="table_bodyStyle"
                        v-if="checkEdit_data != 'false' || checkDelete_data != 'false'"
                    >
                        <template #body="dataTable">
                            <!-- <div class="p-formgrid p-grid" v-if="checkNotAdminPermission(dataTable.data.user_organize)"> -->
                            <!-- checkNotAdminPermission เอาไว้เช็คว่าต้องเป็น User ตัวเองเท่านั้นถึงแก้ได้ ในกรณีที่ไม่ใช่ Admin System  -->
                            <!-- แก้ใหม่ให้เปิดให้แก้ไขได้ -->
                            <div class="p-formgrid col_manege">
                                <div :class="table_BOXmanege" v-if="checkEdit_data != 'false'">
                                    <Button
                                        @click="
                                            disasterPreventInfoModal = true;
                                            editData(dataTable.data.prevent_id);
                                            temp = dataTable.data.prevent_id;
                                        "
                                        icon="pi pi-pencil"
                                        :label="table_editBTN"
                                        class="p-button-rounded p-button-warning"
                                    />
                                </div>
                                <div :class="table_BOXmanege" v-if="checkDelete_data != 'false'">
                                    <Button
                                        @click="
                                            // displayConfirmation = true;
                                            temp = dataTable.data.prevent_id;
                                            deleteAt = '';
                                            alertDisplay(temp, deleteAt);
                                        "
                                        icon="pi pi-trash"
                                        :label="table_deleteBTN"
                                        class="p-button-rounded p-button-danger"
                                    />
                                </div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column headerStyle="width: 0"></Column>
                </div>
            </DataTable>
        </div>

        <!-- Manage data -->
        <Dialog
            :modal="true"
            :visible.sync="disasterPreventInfoModal"
            :style="{ width: '85%' }"
            :contentStyle="{ 'overflow-y': 'auto' }"
            :closable="loadingCreate ? false : true"
            :header="header"
        >
            <div class="confirmation-content" @keyup.enter="saveData_Modal('Modal_Main')">
                <!-- โหลดเพิ่มแก้ไข 1/8-->
                <div class="From_Loading" v-if="loadingCreate">
                    <ProgressSpinner style="width: 120px; height: 120px; color: red" strokeWidth="5" animationDuration="1s" />
                    <div class="waveTextAnimated">
                        <span>กำ</span>
                        <span>ลัง</span>
                        <span>บัน</span>
                        <span>ทึก</span>
                        <span>ข้อ</span>
                        <span>มูล</span>
                        <!-- กำลังบันทึกข้อมูล -->
                    </div>
                </div>
                <!-- โหลดเพิ่มแก้ไข 1/8 จบ-->
                <label>{{ $t('idp_modal_subtitle') }}</label>
                <div class="p-fluid p-mt-3">
                    <div class="p-grid p-col-12 p-lg-12">
                        <div class="p-field p-col-12 p-lg-3">
                            <label for="prevent_type">{{ $t('idp_prevent_type') }} <span class="required-input">*</span></label>
                            <Dropdown
                                v-model="idp_prevent_type"
                                :options="preventTypeOptions"
                                optionLabel="system_name"
                                :filter="true"
                                :class="{
                                    'p-invalid': error_idp_prevent_type && !idp_prevent_type
                                }"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="preventTypeOptions">
                                    <div v-if="preventTypeOptions.value">
                                        <div>{{ preventTypeOptions.value.system_name }}</div>
                                    </div>
                                    <span v-else>
                                        {{ preventTypeOptions.placeholder }}
                                    </span>
                                </template>
                                <template #option="preventTypeOptions">
                                    <div>{{ preventTypeOptions.option.system_name }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_idp_prevent_type && !idp_prevent_type">{{ $t('idp_prevent_type_validate') }}</small>
                        </div>
                        <div class="p-field p-col-12 p-lg-3">
                            <label for="idp_prevent_name">{{ $t('idp_prevent_name') }} <span class="required-input">*</span></label>
                            <InputText
                                id="idp_prevent_name"
                                type="text"
                                v-model="idp_prevent_name"
                                autofocus
                                required="true"
                                :class="{
                                    'p-invalid': error_idp_prevent_name && !idp_prevent_name
                                }"
                                ref="TextBox_1"
                                @keyup.left="moveFocus($event, 'TextBox_14', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_2', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_4', 'Input')"
                            />
                            <small class="p-invalid" v-if="error_idp_prevent_name && !idp_prevent_name">{{ $t('idp_prevent_name_validate') }}</small>
                        </div>

                        <div class="p-field p-col-8 p-lg-4">
                            <label for="idp_organize">{{ $t('response_agency') }} <span class="required-input">*</span></label>
                            <InputText
                                id="idp_organize"
                                type="text"
                                v-model="idp_organize.name"
                                disabled
                                :class="{
                                    'p-invalid': error_idp_organize && !idp_organize.name
                                }"
                            />
                            <small class="p-invalid" v-if="error_idp_organize && !idp_organize.name">{{ $t('iie_organize_validate') }}</small>
                        </div>
                        <div class="p-field p-lg-1">
                            <div>
                                <Button
                                    @click="showOrganize_Form = true"
                                    icon="pi pi-ellipsis-h"
                                    class="p-button-secondary p-mr-1"
                                    ref="TextBox_2"
                                    @keyup.left="moveFocus($event, 'TextBox_1', 'Input')"
                                    @keyup.right="moveFocus($event, 'TextBox_3', 'Button')"
                                    @keyup.down="moveFocus($event, 'TextBox_4', 'Input')"
                                />
                                <Button
                                    @click="idp_organize = {}"
                                    icon="pi pi-times"
                                    class="p-button-danger p-mt-5"
                                    ref="TextBox_3"
                                    @keyup.left="moveFocus($event, 'TextBox_2', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_4', 'Input')"
                                    @keyup.down="moveFocus($event, 'TextBox_4', 'Input')"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="p-grid p-col-12 p-lg-12">
                        <div class="p-field p-col-12 p-lg-3">
                            <label for="idp_location_detail">{{ $t('location') }}</label>
                            <InputText
                                id="idp_location_detail"
                                type="text"
                                v-model="idp_location_detail"
                                required="true"
                                ref="TextBox_4"
                                @keyup.left="moveFocus($event, 'TextBox_3', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_5', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_1', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_5', 'Input')"
                            />
                        </div>

                        <!-- Doe เพิ่มหมุด map V.2 1/9  @input="inputMap_PAT_latlon" -->
                        <div class="p-field p-col-12 p-lg-3">
                            <label for="provinceOptions">{{ $t('province') }}</label>
                            <Dropdown
                                v-model="idp_selectedProvince"
                                @input="inputMap_PAT_latlon"
                                :options="provinceOptions"
                                @change="someHandler('ch-province')"
                                optionLabel="province_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="provinceOptions">
                                    <div v-if="provinceOptions.value">
                                        <div>{{ provinceOptions.value.province_name }}</div>
                                    </div>
                                </template>
                                <template #option="provinceOptions">
                                    <div>{{ provinceOptions.option.province_name }}</div>
                                </template>
                            </Dropdown>
                        </div>

                        <div class="p-field p-col-12 p-lg-3">
                            <label for="amphurOptions">{{ $t('amphur') }}</label>
                            <Dropdown
                                :disabled="idp_isDisabledAmphur == 1"
                                v-model="idp_selectedAmphur"
                                @input="inputMap_PAT_latlon"
                                @change="someHandler('ch-amphur')"
                                :options="amphurOptions"
                                optionLabel="amphur_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="amphurOptions">
                                    <div v-if="amphurOptions.value">
                                        <div>{{ amphurOptions.value.amphur_name }}</div>
                                    </div>
                                </template>
                                <template #option="amphurOptions">
                                    <div>{{ amphurOptions.option.amphur_name }}</div>
                                </template>
                            </Dropdown>
                        </div>

                        <div class="p-field p-col-12 p-lg-3">
                            <label for="tambonOptions">{{ $t('tambon') }}</label>
                            <Dropdown
                                :disabled="idp_isDisabledTambon == 1"
                                v-model="idp_selectedTambon"
                                @input="inputMap_PAT_latlon"
                                :options="tambonOptions"
                                optionLabel="tambon_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="tambonOptions">
                                    <div v-if="tambonOptions.value">
                                        <div>{{ tambonOptions.value.tambon_name }}</div>
                                    </div>
                                </template>
                                <template #option="tambonOptions">
                                    <div>{{ tambonOptions.option.tambon_name }}</div>
                                </template>
                            </Dropdown>
                        </div>
                    </div>
                    <!-- Doe เพิ่มหมุด map V.2 1/9  @input="inputMap_PAT_latlon" จบ-->

                    <div class="p-formgrid p-grid p-col-12 p-lg-12">
                        <div class="p-field p-col-12 p-lg-6">
                            <label for="idp_contact_name">{{ $t('contact_name') }}</label>
                            <InputText
                                id="idp_contact_name"
                                type="text"
                                v-model="idp_contact_name"
                                ref="TextBox_5"
                                @keyup.left="moveFocus($event, 'TextBox_4', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_6', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_4', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_7', 'Input')"
                            />
                        </div>
                        <!-- <div class="p-field p-col">
                <label for="idp_contact_phone">{{ $t("contact_phone") }}</label>
                <InputText
                  id="idp_contact_phone"
                  type="text"
                  v-model="idp_contact_phone"
                  @input="acceptNumberPhone"
                  autofocus
                />
              </div> -->

                        <!-- <div class="p-field p-col">
                <label for="idp_contact_phone">{{ $t("contact_phone") }}</label>
                <InputText
                  id="idp_contact_phone"
                  type="text"
                  v-model="idp_contact_phone"
                  
                  autofocus
                />
              </div> -->

                        <div class="p-field p-col-12 p-lg-6">
                            <label for="idp_contact_phone">เบอร์โทรศัพท์ผู้ติดต่อ (โทรศัพท์มือถือ)</label>
                            <InputText
                                id="idp_contact_phone"
                                type="text"
                                v-model="contact_phone"
                                @input="acceptNumberPhone"
                                :class="{
                                    'p-invalid': error_contact_phone && contact_phone.length !== 12
                                }"
                                ref="TextBox_6"
                                @keyup.left="moveFocus($event, 'TextBox_5', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_7', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_4', 'Input')"
                                @keyup.down="
                                    moveFocus($event, contact_phone_office && contact_phone_office !== '-' ? 'TextBox_8' : 'TextBox_10', 'Input')
                                "
                            />
                            <small class="p-invalid" v-if="error_contact_phone && contact_phone.length !== 12"
                                >กรุณาระบุเบอร์โทรศัพท์ผู้ติดต่อ (โทรศัพท์มือถือ) 10 หลัก</small
                            >
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col-12 p-lg-12">
                        <div class="p-field p-col-12 p-lg-6">
                            <label for="contact_phone_office">เบอร์โทรศัพท์ผู้ติดต่อ (สำนักงาน)</label>
                            <InputText
                                id="contact_phone_office"
                                type="text"
                                v-model="contact_phone_office"
                                @input="acceptNumberPhone2"
                                :class="{
                                    'p-invalid': error_contact_phone_office && contact_phone_office.length !== 11
                                }"
                                ref="TextBox_7"
                                @keyup.left="moveFocus($event, 'TextBox_6', 'Input')"
                                @keyup.right="
                                    moveFocus($event, contact_phone_office && contact_phone_office !== '-' ? 'TextBox_8' : 'TextBox_9', 'Input')
                                "
                                @keyup.up="moveFocus($event, 'TextBox_5', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_9', 'Input')"
                            />
                            <small class="p-invalid" v-if="error_contact_phone_office && contact_phone_office.length !== 11"
                                >กรุณาระบุเบอร์โทรศัพท์ผู้ติดต่อ (สำนักงาน) 9 หลัก</small
                            >
                        </div>

                        <div class="p-field p-col-12 p-lg-6" v-if="contact_phone_office && contact_phone_office !== '-'">
                            <label for="iev_contact_phone">ext. (ต่อเบอร์ภายใน)</label>
                            <InputText
                                id="contact_phone_office_ext"
                                type="text"
                                v-model="contact_phone_office_ext"
                                @input="acceptNumberPhone3"
                                ref="TextBox_8"
                                @keyup.left="moveFocus($event, 'TextBox_7', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_9', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_6', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_10', 'Input')"
                            />
                        </div>
                        <div class="p-field p-col-12 p-lg-6" v-else>
                            <label for="iev_contact_phone">ext. (ต่อเบอร์ภายใน)</label>
                            <InputText
                                disabled
                                id="contact_phone_office_ext"
                                type="text"
                                v-model="contact_phone_office_ext"
                                @input="acceptNumberPhone3"
                                placeholder="กรุณาระบุเบอร์โทรศัพท์ผู้ติดต่อ (สำนักงาน)"
                                ref="TextBox_8"
                                @keyup.left="moveFocus($event, 'TextBox_7', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_9', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_6', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_10', 'Input')"
                            />
                        </div>
                    </div>

                    <!-- Doe เพิ่มหมุด map V.2 2/9  @input="inputMap_latlon" -->
                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-12 p-lg-4">
                            <label for="idp_lat">{{ $t('lat') }}</label>
                            <InputText
                                id="idp_lat"
                                type="text"
                                v-model="idp_lat"
                                @input="inputMap_latlon"
                                ref="TextBox_9"
                                @keyup.left="
                                    moveFocus($event, contact_phone_office && contact_phone_office !== '-' ? 'TextBox_8' : 'TextBox_7', 'Input')
                                "
                                @keyup.right="moveFocus($event, 'TextBox_10', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_7', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_12', 'Input')"
                            />
                        </div>
                        <div class="p-field p-col-12 p-lg-4">
                            <label for="idp_lon">{{ $t('lon') }}</label>
                            <InputText
                                id="idp_lon"
                                type="text"
                                v-model="idp_lon"
                                @input="inputMap_latlon"
                                ref="TextBox_10"
                                @keyup.left="moveFocus($event, 'TextBox_9', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_11', 'Button')"
                                @keyup.up="
                                    moveFocus($event, contact_phone_office && contact_phone_office !== '-' ? 'TextBox_8' : 'TextBox_6', 'Input')
                                "
                                @keyup.down="moveFocus($event, 'TextBox_12', 'Input')"
                            />
                        </div>
                        <!-- Doe เพิ่มหมุด map V.2 2/9  @input="inputMap_latlon" จบ-->
                        <!-- Doe:  เพิ่ม มุดmap 1/4 -->
                        <div class="p-field p-col-12 p-lg-4 p-mt-5">
                            <Button
                                @click="
                                    displayMap = true;
                                    sendM(idp_lat, idp_lon);
                                    sendM_PAT(idp_selectedTambon, idp_selectedAmphur, idp_selectedProvince);
                                "
                                icon="pi pi-map-marker"
                                :label="$t('openMapBtn')"
                                class="p-button-secondary"
                                ref="TextBox_11"
                                @keyup.left="moveFocus($event, 'TextBox_10', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_12', 'Input')"
                                @keyup.up="
                                    moveFocus($event, contact_phone_office && contact_phone_office !== '-' ? 'TextBox_8' : 'TextBox_6', 'Input')
                                "
                                @keyup.down="moveFocus($event, 'TextBox_12', 'Input')"
                            />
                        </div>
                        <!-- Doe:  เพิ่ม มุดmap 1/4 จบ-->
                    </div>

                    <!-- Doe เพิ่มหมุด map V.2 3/9  -->
                    <small class="warningLATLON" v-if="this.error_latlon_P || this.error_latlon_A || this.error_latlon_T || error_latlon_country"
                        >ข้อควรระวัง : ข้อมูลพิกัดที่คุณเลือกไม่สามารถระบุ
                        <span v-if="this.error_latlon_P || error_latlon_country"> จังหวัด </span>
                        <span v-if="this.error_latlon_A || error_latlon_country"> เขต/อำเภอ </span>
                        <span v-if="this.error_latlon_T || error_latlon_country"> แขวง/ตำบล </span>
                        <span> ได้ </span>
                    </small>
                    <!-- Doe เพิ่มหมุด map V.2 3/9  จบ-->

                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-12 p-lg-8">
                            <label for="idp_remark">{{ $t('remark') }} <span class="required-input"> </span></label>
                            <InputText
                                id="idp_remark"
                                type="text"
                                v-model="idp_remark"
                                ref="TextBox_12"
                                @keyup.left="moveFocus($event, 'TextBox_11', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_13', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_9', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_13', 'Button')"
                            />
                        </div>

                        <div class="p-field p-col-12 p-lg-2">
                            <label for="date_create_form">วันที่สร้างข้อมูล <span class="required-input"> </span></label>
                            <InputText id="date_create_form" type="text" v-model="date_create_form" autofocus disabled />
                        </div>
                        <div class="p-field p-col-12 p-lg-2">
                            <label for="date_update_form">{{ $t('imp_update_info_date') }}<span class="required-input"> </span></label>
                            <InputText id="date_update_form" type="text" v-model="date_update_form" autofocus disabled />
                        </div>
                    </div>

                    <hr />
                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-12 p-lg-8">
                            <label for="disasterOptions">{{ $t('related_disaster') }}</label>
                            <MultiSelect
                                v-model="idp_disaster"
                                :options="disasterTypeOptions"
                                optionLabel="system_name"
                                :placeholder="$t('placeholderSelectBox')"
                                :filter="true"
                                class="multiselect-custom"
                                :clearFilterMultiSelect="multiSelectClearFilerValue"
                            >
                                <template #value="slotProps">
                                    <div class="item item-value" v-for="option of slotProps.value" :key="option.id">
                                        <div>{{ option.system_name }}</div>
                                    </div>
                                    <template v-if="!slotProps.value || slotProps.value.length === 0">
                                        {{ $t('placeholderSelectBox') }}
                                    </template>
                                </template>
                                <template #option="slotProps">
                                    <div class="item">
                                        <div class="EV_disasterOptions">{{ slotProps.option.system_name }}</div>
                                    </div>
                                </template>
                            </MultiSelect>
                        </div>

                        <div class="p-field p-col-12 p-lg-8 p-mt-1">
                            <DataTable
                                :value="disaster_table"
                                :scrollable="true"
                                scrollHeight="500px"
                                :paginator="true"
                                :rows="5"
                                dataKey="id"
                                :rowHover="true"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                :rowsPerPageOptions="[5, 10, 20, 50]"
                                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
                            >
                                <template #empty>{{ $t('TableEmpty') }}</template>
                                <Column field="system_name" :header="$t('support_disaster')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        {{ dataTable.data.system_name }}
                                    </template>
                                </Column>
                                <Column :header="$t('controlTable')" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        <div class="p-formgrid p-grid">
                                            <div class="p-field p-col-6">
                                                <Button
                                                    @click="
                                                        // displayConfirmation = true;
                                                        disasterDelete = dataTable.data;
                                                        deleteAt = 'disaster-table';
                                                        alertDisplay(disasterDelete, deleteAt);
                                                    "
                                                    icon="pi pi-trash"
                                                    :label="$t('deleteBtn')"
                                                    class="p-button-rounded p-button-danger"
                                                />
                                            </div>
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <!-- โหลดเพิ่มแก้ไข 2/8-->
                <Button
                    v-if="selectedData != ''"
                    :label="$t('cancelBtn')"
                    icon="pi pi-times"
                    class="p-button-text"
                    :disabled="loadingCreate ? true : false"
                    @click="clearData()"
                    ref="TextBox_13"
                    @keyup.left="moveFocus($event, 'TextBox_12', 'Input')"
                    @keyup.right="moveFocus($event, 'TextBox_14', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_12', 'Input')"
                />
                <Button
                    v-else
                    :label="$t('clearBtn')"
                    icon="pi pi-times"
                    class="p-button-text"
                    :disabled="loadingCreate ? true : false"
                    @click="clearData()"
                    ref="TextBox_13"
                    @keyup.left="moveFocus($event, 'TextBox_12', 'Input')"
                    @keyup.right="moveFocus($event, 'TextBox_14', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_12', 'Input')"
                />
                <Button
                    :label="$t('saveBtn')"
                    icon="pi pi-check"
                    class="p-button-text"
                    :disabled="loadingCreate ? true : false"
                    @click="saveData()"
                    ref="TextBox_14"
                    @keyup.left="moveFocus($event, 'TextBox_13', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_1', 'Input')"
                    @keyup.up="moveFocus($event, 'TextBox_12', 'Input')"
                />
                <!-- โหลดเพิ่มแก้ไข 2/8 จบ-->
            </template>
        </Dialog>

        <Dialog :modal="true" :header="$t('ConfirmDelete')" :visible.sync="displayConfirmation" :style="{ width: '350px' }">
            <div class="confirmation-content p-mt-3">
                <i class="pi pi-exclamation-triangle p-mr-3 p-mt2" style="font-size: 2rem" />
                <span>{{ $t('ConfirmDeleteSub') }}</span>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" @click="displayConfirmation = false" class="p-button-text" />
                <Button :label="$t('confirmBtn')" icon="pi pi-check" @click="confirmDelete(temp)" class="p-button-text" autofocus />
            </template>
        </Dialog>

        <Dialog :modal="true" :header="$t('map')" :visible.sync="displayMap" :style="{ width: '700px' }">
            <div class="confirmation-content p-mt-3" style="padding-bottom: 20px">
                <!-- Doe : เพิ่ม มุดmap 2/4 -->
                <!-- Doe เพิ่มหมุด map V.2 4/9  -->
                <map-area @selectMap="selectMap_passValue" :latlon="this.latlon" :PAT="this.PAT" :FSS="{}" @selectMap_PAT="receiveM_PAT"></map-area>
                <!-- Doe เพิ่มหมุด map V.2 4/9  จบ-->
                <!-- Doe :  เพิ่ม มุดmap 2/4 -->
            </div>
            <Button :label="$t('saveBtn')" icon="pi pi-check" class="p-button-text" @click="selectMap_displayMap()" />
        </Dialog>

        <!-- Are you sure for close this modal -->
        <Dialog :modal="true" :header="$t('ConfirmCloseModal')" :visible.sync="displayConfirmationCloseModal" :style="{ width: '350px' }">
            <div class="confirmation-content p-mt-3">
                <span>{{ $t('ConfirmCloseModalSub') }}</span>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" @click="displayConfirmationCloseModal = false" class="p-button-text" />
                <Button :label="$t('confirmBtn')" icon="pi pi-check" @click="closeAllModal()" class="p-button-text" autofocus />
            </template>
        </Dialog>

        <!-- Doe PDF เลือกได้  -->
        <Dialog header="ตั้งค่า " :visible.sync="displayEditPDF" :style="{ width: '25rem' }" :contentStyle="{ 'overflow-y': 'visible' }">
            <label>ตั้งค่าการแสดงข้อมูลตารางและการส่งออกข้อมูล</label>
            <div style="margin: 2.5rem 1rem 0 1rem">
                <div class="p-formgrid p-grid">
                    <div class="p-field p-col-12">
                        <MultiSelect
                            v-model="columnsSelectorDialog"
                            :options="columns"
                            optionLabel="title"
                            :placeholder="$t('placeholderSelectBox')"
                            :filter="true"
                            class="multiselect-custom"
                            :clearFilterMultiSelect="multiSelectClearFilerValue"
                        >
                            <template #value="slotProps">
                                <div class="item item-value" v-for="option of slotProps.value" :key="option.dataKey">
                                    <div>{{ option.title }}</div>
                                </div>
                                <template v-if="!slotProps.value || slotProps.value.length === 0">
                                    {{ $t('placeholderSelectBox') }}
                                </template>
                            </template>
                            <template #option="slotProps">
                                <div class="item">
                                    <div>{{ slotProps.option.title }}</div>
                                </div>
                            </template>
                        </MultiSelect>
                        <div style="margin-top: 1rem; display: flex; justify-content: flex-end">
                            <Button
                                @click="
                                    ClearEditPDF();
                                    multiSelectClearFilerValue += 1;
                                "
                                class="p-button-clear"
                                :label="'ล้างข้อมูล'"
                                style="margin-right: 1rem"
                            />
                            <Button @click="SelectAllEditPDF()" class="p-button-info" :label="'เลือกทั้งหมด'" />
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <div>
                    <Button @click="CloseEditPDF()" :label="'ยกเลิก'" icon="pi pi-times" class="p-button-text" />
                    <Button @click="SaveEditPDF()" :label="'บันทึก'" icon="pi pi-check" class="p-button-text" />
                </div>
            </template>
        </Dialog>
        <!-- Doe PDF เลือกได้ -->
    </div>
</template>

<script>
import organizeForm from '../OrganizeTableForm.vue';
import organizeTable from '../../Report/OrganizeMultiSelectTable.vue';
import mapArea from '../Map';
// Doe : PDF 2/3
// เพิ่ม pdf กับ font
// import { jsPDF } from "jspdf";
// import {font} from '../../../../public/assets/font/Sarabun-Regular-normal';
// Doe : PDF 2/3 จบ
import moment from 'moment';

import textFooter from '../../../mixins/textFooter_Search_html';

export default {
    name: 'initial-disaster',
    components: {
        organizeTable,
        organizeForm,
        mapArea,
        textFooter
    },
    data() {
        return {
            searchTimeout: null,
            searchInputRef: null,
            temp: null,
            multiSelectClearFilerValue: 0,
            dropdownClearFilerValue: 0,
            date: moment().locale('th').add(543, 'year').format('l'),
            // Doe ค้นหา  2/5
            filter: '',
            ms: false,
            cloneTable: [],
            // Doe ค้นหา  2/5 จบ

            // Doe โหลด โทรศัพท์
            // Doe width 1/4
            window: {
                width: 0,
                height: 0
            },

            //Search bar variable
            checkRole: null,
            checkView_data: null,
            checkAdd_data: null,
            checkEdit_data: null,
            checkDelete_data: null,

            prevent_name: '',
            preventTypeOptions: [],
            preventTypeSelect: null,
            disasterTypeOptions: [],
            disasterTypeSelected: null,
            location: '',
            prevent_code: '',
            selectedOrganize: {},

            displayConfirmation: false,
            deleteAt: '',
            disasterDelete: {},
            displayMap: false,
            filters: {},
            selectedDisasterPreventInfo: [],

            disasterPreventInfo_Table: [],
            provinceOptions: [],
            selectedProvince: null,
            amphurOptions: [],
            selectedAmphur: null,
            isDisabledAmphur: 1,
            idp_isDisabledAmphur: 1,
            tambonOptions: [],
            selectedTambon: null,
            isDisabledTambon: 1,
            idp_isDisabledTambon: 1,

            showOrganize: false,
            showOrganize_Form: false,
            selectedData: '',
            disasterPreventInfoModal: false,
            idp_prevent_type: null,
            idp_prevent_name: '',
            idp_organize: {},
            idp_location_detail: '',
            idp_selectedProvince: null,
            idp_selectedAmphur: null,
            idp_selectedTambon: null,
            idp_contact_name: '',
            idp_contact_phone: '',
            idp_lat: '',
            idp_lon: '',
            idp_remark: '',
            idp_disaster: null,
            disaster_table: [],
            error_idp_prevent_name: false,
            error_idp_organize: false,
            error_idp_prevent_type: false,
            header: this.$i18n.t('idp_modal_title_add'),
            displayConfirmationCloseModal: false,
            tempFor_displayConfirmationCloseModal: '',

            date_create_form: '',
            date_update_form: '',

            // เพิ่ม มุดmap 3/4
            //  Doe เพิ่มหมุด map V.2 5/9  -->
            latlon: {},
            PAT: {},
            sP: [],
            sA: [],
            error_latlon_country: false,
            error_latlon_land: false,
            error_latlon_P: false,
            error_latlon_A: false,
            error_latlon_T: false,
            //  Doe เพิ่มหมุด map V.2 5/9  จบ-->
            // เพิ่ม มุดmap 3/4 จบ

            contact_phone: '',
            contact_phone_office: '',
            contact_phone_office_ext: '',

            error_contact_phone: false,
            error_contact_phone_office: false,
            error_contact_phone_office_ext: false,

            iev_phone: [],

            loading: false,

            selectedOrganizeData: [],
            organize_table: [],
            parentmessage_organize: null,
            setOpenModal_Organize: '',
            setOpenModal_OrganizeMulti: '',

            // โหลดเพิ่มแก้ไข 3/8
            loadingCreate: false,
            // โหลดเพิ่มแก้ไข 3/8 จบ

            //
            text_Footer: false,
            Clone_Data_text_Footer: [],
            Data_text_Footer: [
                {
                    DataName: 'หน่วยงานที่รับผิดชอบ',
                    textShow: ''
                },
                {
                    DataName: 'ชื่อระบบป้องกัน',
                    textShow: ''
                },
                {
                    DataName: 'ประเภทระบบป้องกัน',
                    textShow: ''
                },
                {
                    DataName: 'ประเภทสาธารณภัย',
                    textShow: ''
                },
                {
                    DataName: 'จังหวัด',
                    textShow: ''
                },
                {
                    DataName: 'เขต/อำเภอ',
                    textShow: ''
                },
                {
                    DataName: 'แขวง/ตำบล',
                    textShow: ''
                },
                {
                    DataName: 'รหัสระบบป้องกัน',
                    textShow: ''
                },
                {
                    DataName: 'ที่ตั้ง',
                    textShow: ''
                }
            ],

            table_BOXmanege: window.innerWidth > 700 ? 'p-field p-col' : '',
            table_editBTN: window.innerWidth > 700 ? this.$i18n.t('editBtn') : '',
            table_deleteBTN: window.innerWidth > 700 ? this.$i18n.t('deleteBtn') : '',

            table_headerStyle: this.checkInnerWidth('15rem', 'Column'),
            table_bodyStyle: this.checkInnerWidth('15rem', 'Body'),

            // Doe PDF เลือกได้  2/5
            setPDF_Hor: 'l',
            setPosition_Hor: [802, 34, 802, 570],
            setPDF_Ver: 'p',
            setPosition_Ver: [570, 34, 575, 815],
            setPDF_Styles: 'grid',
            setnamePDF: 'ตารางข้อมูลระบบป้องกัน/บรรเทาสาธารณภัย',
            setPDF_fillColor: [95, 154, 250],
            setPDF_Margin: { left: 15, right: 15 },

            PDF_minCellWidthVer: 70,
            PDF_FontHeaderVer: 11,
            PDF_FontBodyVer: 8,

            PDF_BodySizeSelect: {},
            PDF_BodySize: {
                index: { cellWidth: 28 },
                system_name: { cellWidth: 65 },
                prevent_location: { cellWidth: 65 },
                text_tel_detail: { cellWidth: 50 }
            },

            PDF_minCellWidthHor: 70,
            PDF_FontHeaderHor: 15,
            PDF_FontBodyHor: 12,

            PDF_BodySizeHorSelect: {},
            PDF_BodySizeHor: {
                index: { cellWidth: 35 }
            },
            columns: [
                { title: 'ลำดับ', dataKey: 'index' },
                { title: 'ชื่อระบบป้องกัน', dataKey: 'prevent_name' },
                { title: 'ประเภทระบบป้องกัน', dataKey: 'system_name' },
                { title: 'สาธารณภัยที่เกี่ยวข้อง', dataKey: 'disaster_details' },
                { title: 'ที่ตั้ง', dataKey: 'prevent_location' },
                { title: 'ชื่อผู้ติดต่อ', dataKey: 'prevent_contact_name' },
                // {title: "เบอร์โทรศัพท์ผู้ติดต่อ", dataKey: "prevent_contact_phone" },
                { title: 'เบอร์โทรศัพท์ผู้ติดต่อ', dataKey: 'text_tel_detail' },
                { title: 'วันที่สร้างข้อมูล', dataKey: 'date_create_ddmmyy' },
                { title: 'วันที่ปรับปรุงข้อมูล', dataKey: 'date_update_ddmmyy' }
            ],

            columnsSelector: null,
            columnsSelectorDialog: null,

            displayEditPDF: false,

            columns_index: true,
            columns_prevent_name: true,
            columns_system_name: true,
            columns_disaster_details: true,
            columns_prevent_location: true,
            columns_prevent_contact_name: true,
            columns_prevent_contact_phone: true,

            columns_date_create: true,
            columns_date_update: true,

            columns_disabled: true,
            // Doe PDF เลือกได้  2/5  จบ

            // Doe : PDF 3/3
            items: [
                {
                    label: ' แนวตั้ง',
                    command: () => {
                        this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวตั้ง', life: 3000 });

                        let columns = this.columnsSelector;

                        const Body_setCenter = ['index'];

                        const PintPDF = {
                            streak: this.setPDF_Ver,
                            setPosition: this.setPosition_Ver,
                            PDF_Styles: this.setPDF_Styles,
                            data: this.$refs.dt.processedData,
                            columns: columns,
                            columnsStyles: this.PDF_BodySizeSelect,
                            FileName: this.setnamePDF,
                            checkBody_Center: true,
                            Body_Center: Body_setCenter,
                            Col_FontSize: this.PDF_FontHeaderVer,
                            Body_FontSize: this.PDF_FontBodyVer,
                            minCell: this.PDF_minCellWidthVer,
                            marginPDF: this.setPDF_Margin,
                            fillColorPDF: this.setPDF_fillColor
                        };
                        this.printPDF(PintPDF);
                    }
                },

                {
                    label: 'แนวนอน',
                    command: () => {
                        this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวนอน', life: 3000 });

                        let columns = this.columnsSelector;

                        const Body_setCenter = ['index'];
                        const PintPDF = {
                            streak: this.setPDF_Hor,
                            setPosition: this.setPosition_Hor,
                            PDF_Styles: this.setPDF_Styles,
                            data: this.$refs.dt.processedData,
                            columns: columns,
                            columnsStyles: this.PDF_BodySizeHorSelect,
                            FileName: this.setnamePDF,
                            checkBody_Center: true,
                            Body_Center: Body_setCenter,
                            Col_FontSize: this.PDF_FontHeaderHor,
                            Body_FontSize: this.PDF_FontBodyHor,
                            minCell: this.PDF_minCellWidthHor,
                            marginPDF: this.setPDF_Margin,
                            fillColorPDF: this.setPDF_fillColor
                        };
                        this.printPDF(PintPDF);
                    }
                }
            ]
            // Doe : PDF 3/3 จบ
        };
    },
    watch: {
        async disasterPreventInfoModal(val) {
            const today = new Date();
            const thaiDate = today.toLocaleDateString('th-TH', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });

            if (val == false) {
                if (
                    this.tempFor_displayConfirmationCloseModal == '' &&
                    this.selectedData == '' &&
                    this.idp_prevent_type != null &&
                    this.idp_prevent_name != '' &&
                    this.idp_organize.name != undefined
                ) {
                    // this.displayConfirmationCloseModal = true;
                    this.$fire({
                        title: 'ยืนยันการปิดหน้าต่างจัดการข้อมูล',
                        text: 'คุณต้องการออกจากการจัดการข้อมูลใช่หรือไม่ ?',

                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'ตกลง',
                        cancelButtonText: 'ยกเลิก'
                    }).then((result) => {
                        if (result.value) {
                            this.disasterPreventInfoModal = false;
                            this.clearData();
                        } else {
                            this.disasterPreventInfoModal = true;
                        }
                    });
                } else {
                    this.clearData();
                    await this.axios
                        .post(`${this.$url_service}/initial/option`, {
                            body: { group: 'dg-02' }
                        })
                        .then((response) => {
                            (this.disasterTypeOptions = response.data.data),
                                this.disasterTypeOptions.splice(0, 0, {
                                    system_id: 'getall',
                                    system_name: this.$i18n.t('selectAll')
                                });
                        });
                    await this.axios
                        .post(`${this.$url_service}/initial/option`, {
                            body: { group: 'dg-05' }
                        })
                        .then((response) => {
                            (this.preventTypeOptions = response.data.data),
                                this.preventTypeOptions.splice(0, 0, {
                                    system_id: 'getall',
                                    system_name: this.$i18n.t('selectAll')
                                });
                        });

                    await this.axios
                        .post(`${this.$url_service}/general/country`, {
                            body: { topic: 'get-province' }
                        })
                        .then((response) => {
                            (this.provinceOptions = response.data.data),
                                this.provinceOptions.splice(0, 0, {
                                    province_id: 'getall',
                                    province_name: this.$i18n.t('selectAll')
                                });
                        });
                }
            } else {
                if (this.temp === null) {
                    this.date_create_form = thaiDate;
                    this.date_update_form = thaiDate;

                    this.decodeToken = this.decodeJWT(localStorage.getItem('token'));
                    this.idp_organize = {
                        id: this.decodeToken.organize_id,
                        name: this.decodeToken.organize_name
                    };
                }

                await this.axios
                    .post(`${this.$url_service}/initial/option`, {
                        body: { group: 'dg-02' }
                    })
                    .then((response) => {
                        this.disasterTypeOptions = response.data.data;
                    });
                await this.axios
                    .post(`${this.$url_service}/initial/option`, {
                        body: { group: 'dg-05' }
                    })
                    .then((response) => {
                        this.preventTypeOptions = response.data.data;
                    });

                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-province'
                        }
                    })
                    .then((response) => (this.provinceOptions = response.data.data));
            }
        },

        displayConfirmationCloseModal(val) {
            if (val == true) {
                this.disasterPreventInfoModal = true;
            }
        },

        async selectedProvince(val) {
            this.selectedAmphur = null;
            if (val != null) {
                this.isDisabledAmphur = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-amphur',
                            province_id: val.province_id
                        }
                    })
                    .then((response) => {
                        (this.amphurOptions = response.data.data),
                            this.amphurOptions.splice(0, 0, {
                                amphur_id: 'getall',
                                amphur_name: this.$i18n.t('selectAll')
                            });
                    });
            } else {
                this.isDisabledAmphur = 1;
                this.selectedAmphur = null;
            }
        },

        async selectedAmphur(val) {
            this.selectedTambon = null;
            if (val != null) {
                this.isDisabledTambon = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-tambon',
                            amphur_id: val.amphur_id
                        }
                    })
                    .then((response) => {
                        (this.tambonOptions = response.data.data),
                            this.tambonOptions.splice(0, 0, {
                                tambon_id: 'getall',
                                tambon_name: this.$i18n.t('selectAll')
                            });
                    });
            } else {
                this.isDisabledTambon = 1;
                this.selectedTambon = null;
            }
        },

        idp_disaster(val) {
            if (val != null) {
                this.disaster_table = [];
                for (let i = 0; i < val.length; i++) {
                    this.disaster_table.push(val[i]);
                }
            }
        },

        async idp_selectedProvince(val) {
            if (val != null) {
                this.idp_isDisabledAmphur = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-amphur',
                            province_id: val.province_id
                        }
                    })
                    .then((response) => (this.amphurOptions = response.data.data));
            } else {
                this.idp_isDisabledAmphur = 1;
                this.idp_selectedAmphur = null;
            }
        },

        async idp_selectedAmphur(val) {
            if (val != null) {
                this.idp_isDisabledTambon = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-tambon',
                            amphur_id: val.amphur_id
                        }
                    })
                    .then((response) => (this.tambonOptions = response.data.data));
            } else {
                this.idp_isDisabledTambon = 1;
                this.idp_selectedTambon = null;
            }
        },

        selectedData(val) {
            if (val != '') {
                if (val.location_id == 'null') {
                    this.idp_selectedProvince = null;
                    this.idp_selectedAmphur = null;
                    this.idp_selectedTambon = null;
                } else {
                    this.idp_selectedProvince = {
                        province_id: val.province_id,
                        province_name: val.province_name
                    };
                    this.idp_selectedAmphur = {
                        amphur_id: val.amphur_id,
                        amphur_name: val.amphur_name
                    };
                    this.idp_selectedTambon = {
                        tambon_id: val.location_id,
                        tambon_name: val.tambon_name
                    };
                }
            }
        },
        contact_phone(val) {
            // console.log(val)
            if (val.length == 0) {
                this.error_contact_phone = false;
            }
        },
        contact_phone_office(val) {
            // console.log(val)
            if (val.length == 0) {
                this.error_contact_phone_office = false;
                this.contact_phone_office_ext = '';
            }
        },

        // Doe PDF เลือกได้
        columnsSelector(val) {
            if (val.length == 0) {
                this.disasterPreventInfo_Table = [];
            } else {
                this.disasterPreventInfo_Table = this.cloneTable;
            }
        },

        showOrganize(val) {
            if (val == true) {
                if (this.organize_table.length > 0) {
                    this.parentmessage_organize = this.organize_table;
                } else {
                    this.parentmessage_organize = [];
                }
            }
        }
    },
    created() {
        // Doe โหลด โทรศัพท์
        // Doe width 2/4
        window.addEventListener('resize', this.handleResize);
        this.handleResize();

        if (this.window.width <= 430) {
            // console.log("this.window.width is",this.window.width)
            // console.log("00000")
            this.searchMenu();
        } else {
            // console.log("this.window.width is",this.window.width)
            // console.log("1111")
            this.ms = true;
            this.initialData();
        }
        // Doe โหลด โทรศัพท์

        // Doe PDF เลือกได้  4/5
        this.columnsSelector = this.columns;
        this.PDF_BodySizeSelect = this.PDF_BodySize;
        this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;
        // Doe PDF เลือกได้  4/5  จบ

        const decodedToken = this.decodeJWT(localStorage.getItem('token'));
        // this.initialData();
        this.checkRole = decodedToken.permission_id;

        this.checkView_data = decodedToken.view_data;
        this.checkAdd_data = decodedToken.add_data;
        this.checkEdit_data = decodedToken.edit_data;
        this.checkDelete_data = decodedToken.delete_data;

        // console.log(`checkRole = ${this.checkRole} `);
        // console.log(`checkView_data = ${this.checkView_data} `);
        // console.log(`checkAdd_data = ${this.checkAdd_data} `);
        // console.log(`checkEdit_data = ${this.checkEdit_data} `);
        // console.log(`checkDelete_data = ${this.checkDelete_data} `);

        this.Clone_Data_text_Footer = this.setCloneData(this.Data_text_Footer);
    },

    // Doe โหลด โทรศัพท์
    // Doe width 3/4
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    // Doe โหลด โทรศัพท์

    mounted() {
        this.$nextTick(() => {
            this.searchInputRef = this.$refs.searchInput?.$el || this.$refs.searchInput;
        });
    },

    methods: {
        async updateDates() {
            try {
                this.loadingCreate = true;
                const userOrg = this.getUserOrganize();
                const userId = this.getUsername();

                // Format selected records
                const formattedRecords = this.selectedDisasterPreventInfo.map((item) => ({
                    prevent_id: item.prevent_id,
                    ...item
                }));

                // console.log('formattedRecords', formattedRecords);

                const response = await this.axios.post(`${this.$url_service}/initial/prevent?user=${userId}`, {
                    body: {
                        topic: 'edit-prevent_date_multiple',
                        selectedDisasterPreventInfo: formattedRecords,
                        userOrg: userOrg
                    }
                });

                // Check if response exists and has data
                if (response && response.data) {
                    if (response.data.success) {
                        this.loadingCreate = false;
                        this.tempFor_displayConfirmationCloseModal = 'add';
                        this.disasterPreventInfoModal = false;

                        await this.$fire({
                            type: 'success',
                            title: 'ปรับปรุงข้อมูล',
                            text: `อัปเดตข้อมูลระบบป้องกัน/บรรเทาสาธารณภัยจำนวน ${response.data.updatedIds?.length || 0} รายการ`,
                            timer: 3000,
                            confirmButtonColor: '#28B463'
                        });

                        // Refresh data after successful update
                        await this.searchDisasterPreventInfo();
                        return; // Exit function after successful update
                    }
                    // Move error handling for unsuccessful response here
                    throw new Error(response.data.message || 'ไม่สามารถอัปเดตข้อมูลได้');
                }
            } catch (error) {
                console.error('Update error:', error); // Add logging for debugging
                this.loadingCreate = false;
                await this.$fire({
                    type: 'error',
                    title: 'เกิดข้อผิดพลาด',
                    text: error.response?.data?.message || error.message || 'ไม่สามารถอัปเดตข้อมูลได้',
                    timer: 3000,
                    confirmButtonColor: '#DC3545'
                });
            } finally {
                this.loadingCreate = false;
            }
        },

        onSelectAll(checked) {
            if (checked) {
                this.selectedDisasterPreventInfo = [...this.disasterPreventInfo_Table];
            } else {
                this.selectedDisasterPreventInfo = [];
            }
            this.$emit('selectedDisasterPreventInfo', this.selectedDisasterPreventInfo);
            // console.log('selectedDisasterPreventInfo', this.selectedDisasterPreventInfo);
        },

        onSelectRow(row, checked) {
            if (checked) {
                if (!this.selectedDisasterPreventInfo.some((item) => item.prevent_id === row.prevent_id)) {
                    this.selectedDisasterPreventInfo.push(row);
                }
            } else {
                this.selectedDisasterPreventInfo = this.selectedDisasterPreventInfo.filter((item) => item.prevent_id !== row.prevent_id);
            }
            this.$emit('selectedDisasterPreventInfo', this.selectedDisasterPreventInfo);
            // console.log('selectedDisasterPreventInfo', this.selectedDisasterPreventInfo);
        },

        decodeJWT(token) {
            try {
                const payload = token.split('.')[1];
                // Replace Base64URL to Base64
                const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
                // Decode Base64
                const decodedPayload = atob(base64);
                // Handle UTF-8 encoding and return the parsed JSON object
                const jsonPayload = decodeURIComponent(
                    decodedPayload
                        .split('')
                        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                        .join('')
                );
                return JSON.parse(jsonPayload);
            } catch (error) {
                console.error('Failed to decode JWT token:', error);
                return null;
            }
        },

        saveData_Modal(ModalName) {
            if (ModalName === 'search') {
                if (!this.isFocused('TextBox_1_search') && !this.isFocused('TextBox_5_search') && !this.isFocused('TextBox_6_search')) {
                    this.searchDisasterPreventInfo();
                }
            } else if (ModalName === 'Modal_Main') {
                if (
                    !this.isFocused('TextBox_2') &&
                    !this.isFocused('TextBox_3') &&
                    !this.isFocused('TextBox_11') &&
                    !this.isFocused('TextBox_13') &&
                    !this.isFocused('TextBox_14')
                ) {
                    this.saveData();
                }
            }
        },
        exportCSV() {
            debugger;
            this.$refs.dt.exportCSV();
        },

        // Doe โหลด โทรศัพท์
        // Doe width 4/4
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;

            this.table_BOXmanege = window.innerWidth > 700 ? 'p-field p-col' : '';
            this.table_editBTN = window.innerWidth > 700 ? this.$i18n.t('editBtn') : '';
            this.table_deleteBTN = window.innerWidth > 700 ? this.$i18n.t('deleteBtn') : '';
            if (window.innerWidth > 700) {
                this.table_headerStyle = this.checkInnerWidth('15rem', 'Column');
                this.table_bodyStyle = this.checkInnerWidth('15rem', 'Body');
            } else {
                this.table_headerStyle = this.checkInnerWidth('105px', 'Column');
                this.table_bodyStyle = this.checkInnerWidth('105px', 'Body');
            }
        },

        async searchMenu() {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            // console.log("79")
            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-02' }
                })
                .then((response) => {
                    (this.disasterTypeOptions = response.data.data),
                        this.disasterTypeOptions.splice(0, 0, {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        });
                });
            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-05' }
                })
                .then((response) => {
                    (this.preventTypeOptions = response.data.data),
                        this.preventTypeOptions.splice(0, 0, {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        });
                });

            await this.axios
                .post(`${this.$url_service}/general/country`, {
                    body: {
                        topic: 'get-province'
                    }
                })
                .then((response) => {
                    (this.provinceOptions = response.data.data),
                        this.provinceOptions.splice(0, 0, {
                            province_id: 'getall',
                            province_name: this.$i18n.t('selectAll')
                        });
                });
        },

        // Doe โหลด โทรศัพท์

        // Doe ค้นหา  3/6
        search() {
            // Store reference to the input element
            if (event && event.target) {
                this.searchInputRef = event.target;
            }

            // Cancel any existing timeout
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout);
            }

            // Use debounce to delay processing
            this.searchTimeout = setTimeout(() => {
                if (this.filter != '' && this.disasterPreventInfo_Table !== []) {
                    this.disasterPreventInfo_Table = this.cloneTable.filter((item) => {
                        return (
                            (this.columns_prevent_name ? item.prevent_name.includes(this.filter) : '') ||
                            (this.columns_system_name ? item.system_name.includes(this.filter) : '') ||
                            (this.columns_disaster_details ? item.disaster_details.includes(this.filter) : '') ||
                            (this.columns_prevent_location ? item.prevent_location.includes(this.filter) : '') ||
                            (this.columns_prevent_contact_name ? item.prevent_contact_name.includes(this.filter) : '') ||
                            (this.columns_prevent_contact_phone ? item.text_tel_detail.includes(this.filter) : '') ||
                            (this.columns_date_create ? item.date_create_ddmmyy.includes(this.filter) : '') ||
                            (this.columns_date_update ? item.date_update_ddmmyy.includes(this.filter) : '')
                        );
                    });

                    for (let i = 0; i < this.disasterPreventInfo_Table.length; i++) {
                        this.disasterPreventInfo_Table[i]['index'] = i + 1;
                    }
                } else {
                    this.disasterPreventInfo_Table = [...this.cloneTable];
                    for (let i = 0; i < this.disasterPreventInfo_Table.length; i++) {
                        this.disasterPreventInfo_Table[i]['index'] = i + 1;
                    }
                }

                // Restore focus to input element after rendering completes
                this.$nextTick(() => {
                    if (this.searchInputRef) {
                        this.searchInputRef.focus();

                        // Place cursor at the end of the text
                        const length = this.searchInputRef.value.length;
                        this.searchInputRef.setSelectionRange(length, length);
                    }
                });
            }, 300); // 300ms delay before processing
        },
        // Doe ค้นหา  3/6 จบ

        async initialData() {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์
            this.ms = true;
            this.filter = '';
            this.cloneTable = [];
            this.loading = true;

            await this.axios
                .post(`${this.$url_service}/initial/prevent`, {
                    body: {
                        topic: 'get-table',
                        userOrg
                    }
                })
                // Doe : เพิ่ม ลำดับ 3/4
                .then((response) => {
                    this.disasterPreventInfo_Table = response.data.data;
                    // Doe ค้นหา  4/6
                    this.cloneTable = response.data.data;
                    // Doe ค้นหา  4/6
                    for (let i = 0; i < this.disasterPreventInfo_Table.length; i++) {
                        this.disasterPreventInfo_Table[i]['index'] = i + 1;
                    }
                    // console.log("this.disasterPreventInfo_Table == id  ",this.disasterPreventInfo_Table)
                    // Doe : เพิ่ม ลำดับ 3/4 จบ

                    // รวม disaster_id
                    var data1 = this.disasterPreventInfo_Table.map((obj) => (data1 = obj.disaster_id));

                    // console.log('data1 ',data1);

                    for (let index = 0; index < data1.length; index++) {
                        const element = data1[index];

                        // console.log('element > 1 ',index,'=',JSON.parse(element));
                        // console.log('element > 1 ',index,'=',JSON.parse(element).length);
                        var textAll = '';
                        for (let index = 0; index < JSON.parse(element).length; index++) {
                            const element2 = JSON.parse(element)[index].system_name;
                            // console.log('element2 ',element2);
                            textAll += `${element2}\n`;
                        }
                        // console.log({disaster_details :textAll} );

                        this.disasterPreventInfo_Table[index]['disaster_details'] = textAll;
                        // console.log("disaster ",this.disasterPreventInfo_Table)
                    }

                    // Doe ช่องว่างใส่ ขีด
                    this.formatData(this.disasterPreventInfo_Table);
                });

            if (this.columns_disabled == true) {
                this.disasterPreventInfo_Table = this.cloneTable;
            } else {
                this.disasterPreventInfo_Table = [];
            }

            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-02' }
                })
                .then((response) => {
                    (this.disasterTypeOptions = response.data.data),
                        this.disasterTypeOptions.splice(0, 0, {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        });
                });
            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-05' }
                })
                .then((response) => {
                    (this.preventTypeOptions = response.data.data),
                        this.preventTypeOptions.splice(0, 0, {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        });
                });

            await this.axios
                .post(`${this.$url_service}/general/country`, {
                    body: {
                        topic: 'get-province'
                    }
                })
                .then((response) => {
                    (this.provinceOptions = response.data.data),
                        this.provinceOptions.splice(0, 0, {
                            province_id: 'getall',
                            province_name: this.$i18n.t('selectAll')
                        });
                });
            this.loading = false;
        },
        formatData(data) {
            for (let index = 0; index < data.length; index++) {
                if (data[index].disaster_details == null || data[index].disaster_details == 'null' || data[index].disaster_details == '') {
                    data[index].disaster_details = '-';
                }
                if (data[index].prevent_location == null || data[index].prevent_location == 'null' || data[index].prevent_location == '') {
                    data[index].prevent_location = '-';
                }
                if (
                    data[index].prevent_contact_name == null ||
                    data[index].prevent_contact_name == 'null' ||
                    data[index].prevent_contact_name == ''
                ) {
                    data[index].prevent_contact_name = '-';
                }
                if (
                    data[index].prevent_contact_phone == null ||
                    data[index].prevent_contact_phone == 'null' ||
                    data[index].prevent_contact_phone == ''
                ) {
                    data[index].prevent_contact_phone = '-';
                }

                if (data[index].date_create_ddmmyy == null || data[index].date_create_ddmmyy == 'null' || data[index].date_create_ddmmyy == '') {
                    data[index].date_create_ddmmyy = '-';
                } else {
                    data[index].date_create_ddmmyy = this.changeDateToThai(this.checkDate(data[index].date_create_ddmmyy));
                }

                if (data[index].date_update_ddmmyy == null || data[index].date_update_ddmmyy == 'null' || data[index].date_update_ddmmyy == '') {
                    data[index].date_update_ddmmyy = '-';
                } else {
                    data[index].date_update_ddmmyy = this.changeDateToThai(this.checkDate(data[index].date_update_ddmmyy));
                }
            }
        },
        closeAllModal() {
            // console.log("Close and don`t save data");
            this.disasterPreventInfoModal = false;
            this.displayConfirmationCloseModal = false;
            this.clearData();
        },

        // acceptNumberPhone() {
        //   var x = this.idp_contact_phone
        //     .replace(/\D/g, "")
        //     .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        //   this.idp_contact_phone = !x[2]
        //     ? x[1]
        //     : x[1] + "-" + x[2] + (x[3] ? "-" + x[3] : "");
        // },
        acceptNumberPhone() {
            var x = this.contact_phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            this.contact_phone = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
        },
        acceptNumberPhone2() {
            var x = this.contact_phone_office.replace(/\D/g, '').match(/(\d{0,2})(\d{0,3})(\d{0,4})/);
            this.contact_phone_office = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
        },
        acceptNumberPhone3() {
            var x = this.contact_phone_office_ext.replace(/\D/g, '');
            this.contact_phone_office_ext = x;
        },

        someHandler(message) {
            if (message == 'ch-province') {
                this.idp_selectedAmphur = null;
            }
            if (message == 'ch-amphur') {
                this.idp_selectedTambon = null;
            }
        },

        selectedOrganize_passValue_Form(variable) {
            this.showOrganize_Form = false;
            if (this.disasterPreventInfoModal == false) {
                this.selectedOrganize = {
                    id: variable.organize_id,
                    name: variable.organize_name
                };
            } else {
                this.idp_organize = {
                    id: variable.organize_id,
                    name: variable.organize_name
                };
            }
        },
        checkSelectedOrganize(status) {
            if (status !== '') {
                return true;
            } else {
                return false;
            }
        },
        selectedOrganize_passValue(variable) {
            this.showOrganize = false;
            if (variable != null) {
                if (this.setOpenModal_OrganizeMulti === 'search') {
                    this.organize_table = [];
                    for (let i = 0; i < variable.length; i++) {
                        this.organize_table.push({
                            organize_id: variable[i].organize_id,
                            organize_name: variable[i].organize_name
                        });
                    }
                }
            }
        },

        async searchDisasterPreventInfo() {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            this.ms = true;
            // this.filter='';
            this.cloneTable = [];
            this.loading = true;
            // console.log('this.selectedOrganize', (JSON.stringify(this.selectedOrganize)));
            var userSelectedOrganize = JSON.stringify(this.selectedOrganize);
            if (userSelectedOrganize != '{}') {
                // console.log('userSelectedOrganize != {} ', (JSON.parse(userSelectedOrganize)).id);
                userSelectedOrganize = JSON.parse(userSelectedOrganize).id;
            } else {
                // console.log('userSelectedOrganize ', userSelectedOrganize);
                userSelectedOrganize = this.selectedOrganize;
            }

            const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์
            await this.axios
                .post(`${this.$url_service}/initial/prevent`, {
                    body: {
                        topic: 'search-table',
                        name: this.prevent_name,
                        type: this.preventTypeSelect,
                        disaster: this.disasterTypeSelected,
                        // organize: this.checkPermission() ? this.selectedOrganize : this.getUserOrganize(),
                        province: this.selectedProvince,
                        amphur: this.selectedAmphur,
                        tambon: this.selectedTambon,
                        code: this.prevent_code,
                        location: this.location,
                        // organize: userSelectedOrganize, // เช็คหน่วยงานหลัก
                        organize: this.organize_table,
                        userOrg
                    }
                })
                // Doe : เพิ่ม ลำดับ 3/4
                .then((response) => {
                    this.disasterPreventInfo_Table = response.data.data;
                    // Doe ค้นหา  5/6
                    this.cloneTable = response.data.data;
                    // Doe ค้นหา  5/6
                    for (let i = 0; i < this.disasterPreventInfo_Table.length; i++) {
                        this.disasterPreventInfo_Table[i]['index'] = i + 1;
                    }
                    // รวม disaster_id
                    var data1 = this.disasterPreventInfo_Table.map((obj) => (data1 = obj.disaster_id));

                    // console.log('data1 ',data1);

                    for (let index = 0; index < data1.length; index++) {
                        const element = data1[index];

                        // console.log('element > 1 ',index,'=',JSON.parse(element));
                        // console.log('element > 1 ',index,'=',JSON.parse(element).length);
                        var textAll = '';
                        for (let index = 0; index < JSON.parse(element).length; index++) {
                            const element2 = JSON.parse(element)[index].system_name;
                            // console.log('element2 ',element2);
                            textAll += `${element2}\n`;
                        }
                        // console.log({disaster_details :textAll} );

                        this.disasterPreventInfo_Table[index]['disaster_details'] = textAll;
                        // console.log("disaster ",this.disasterPreventInfo_Table)
                    }
                    // console.log("this.disasterPreventInfo_Table == id  ",this.disasterPreventInfo_Table)

                    // Doe ช่องว่างใส่ ขีด
                    this.formatData(this.disasterPreventInfo_Table);
                    // this.search()

                    this.setSearchText_Footer();
                });
            // Doe : เพิ่ม ลำดับ 3/4 จบ

            if (this.columns_disabled == true) {
                this.disasterPreventInfo_Table = this.cloneTable;
            } else {
                this.disasterPreventInfo_Table = [];
            }

            this.search();
            this.loading = false;
        },
        setSearchText_Footer() {
            this.text_Footer = false;
            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            if (
                this.organize_table.length !== 0 ||
                this.prevent_name !== '' ||
                this.preventTypeSelect !== null ||
                this.disasterTypeSelected !== null ||
                this.selectedProvince !== null ||
                this.selectedAmphur !== null ||
                this.selectedTambon !== null ||
                this.prevent_code !== '' ||
                this.location !== ''
            ) {
                for (let index = 0; index < this.Data_text_Footer.length; index++) {
                    const element = this.Data_text_Footer[index];
                    if (element.DataName === 'หน่วยงานที่รับผิดชอบ' && this.organize_table.length !== 0) {
                        element.textShow = this.setAll_organize_table(this.organize_table);
                    }
                    if (element.DataName === 'ชื่อระบบป้องกัน' && this.prevent_name !== '') {
                        element.textShow = this.prevent_name;
                    }
                    if (element.DataName === 'ประเภทระบบป้องกัน' && this.preventTypeSelect !== null) {
                        element.textShow = this.preventTypeSelect.system_name;
                    }
                    if (element.DataName === 'ประเภทสาธารณภัย' && this.disasterTypeSelected !== null) {
                        element.textShow = this.disasterTypeSelected.system_name;
                    }
                    if (element.DataName === 'จังหวัด' && this.selectedProvince !== null) {
                        element.textShow = this.selectedProvince.province_name;
                    }
                    if (element.DataName === 'เขต/อำเภอ' && this.selectedAmphur !== null) {
                        element.textShow = this.selectedAmphur.amphur_name;
                    }
                    if (element.DataName === 'แขวง/ตำบล' && this.selectedTambon !== null) {
                        element.textShow = this.selectedTambon.tambon_name;
                    }
                    if (element.DataName === 'รหัสระบบป้องกัน' && this.prevent_code !== '') {
                        element.textShow = this.prevent_code;
                    }
                    if (element.DataName === 'ที่ตั้ง' && this.location !== '') {
                        element.textShow = this.location;
                    }
                }
                this.text_Footer = true;
            }
        },
        setAll_organize_table(data) {
            let text = [];
            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                if (element.organize_name !== undefined) {
                    text += element.organize_name + ',';
                }
            }
            return text.slice(0, -1);
        },
        addDisaster() {
            this.disaster_table = [];
            for (let i = 0; i < this.idp_disaster.length; i++) {
                this.disaster_table.push(this.idp_disaster[i]);
            }
        },

        selectMap_passValue(variable) {
            // this.displayMap = false;
            // console.log(variable);
            this.idp_lat = variable.lat;
            this.idp_lon = variable.lng;
        },
        selectMap_displayMap() {
            this.displayMap = false;

            // แจ้งเตือนกรณีไม่ได้ ข้อมูลพิกัด
            // console.log("this.idp_lat",this.idp_lat)
            // console.log("this.idp_lon",this.idp_lon)
            if (this.idp_lat !== null && this.idp_lon !== null && this.idp_lat !== '' && this.idp_lon !== '') {
                this.$fire({
                    title: 'เพิ่มพิกัดสำเร็จ',
                    // text: "ข้อมูลพิกัด",
                    type: 'success',
                    timer: 3000,
                    confirmButtonColor: '#28B463'
                });
            } else {
                this.$fire({
                    title: 'ยังไม่ได้เลือกข้อมูลพิกัด',
                    // text: "ยังไม่ได้เลือกข้อมูลพิกัด",
                    type: 'warning',
                    timer: 3000,
                    confirmButtonColor: '#28B463'
                });
            }
        },

        //  Doe เพิ่มหมุด map V.2 6/9  -->
        async inputMap_latlon() {
            if (this.idp_lat !== '' && this.idp_lat !== null && this.idp_lon !== '' && this.idp_lon !== null) {
                await this.axios
                    .get(`https://api.deemap.com/service/geocode/lat=${this.idp_lat}/lon=${this.idp_lon}/key=0feb00d7e64c5686bf434b9b90ab2d3c`)
                    .then((response) => {
                        // debugger;
                        if (response.data.data.length > 0) {
                            const data = {
                                ADMIN_CODE: response.data.data[0].ADMIN_CODE,
                                provinceName: response.data.data[0].PROV_TNAME,
                                amphurName: response.data.data[0].AMP_TNAME,
                                tambonName: response.data.data[0].TAM_TNAME,
                                postCODE: response.data.data[0].POSTCOD
                            };
                            const element = data.ADMIN_CODE;
                            const country_ID = `${element[0]}${element[1]}`;
                            const land_ID = `${element[2]}${element[3]}`;
                            const province_ID = `${element[4]}${element[5]}`;
                            const amphur_ID = `${element[4]}${element[5]}${element[6]}${element[7]}`;
                            const tambon_ID = `${element[4]}${element[5]}${element[6]}${element[7]}${element[8]}${element[9]}`;

                            if (country_ID == '66' && land_ID !== '00') {
                                this.idp_selectedProvince = {
                                    province_name: data.provinceName,
                                    province_id: province_ID
                                };
                                this.idp_selectedAmphur = {
                                    amphur_name: data.amphurName,
                                    amphur_id: amphur_ID
                                };
                                this.idp_selectedTambon = {
                                    tambon_name: data.tambonName,
                                    tambon_id: tambon_ID
                                };

                                this.error_latlon_country = false;
                                this.error_latlon_land = false;

                                this.error_latlon_P = false;
                                this.error_latlon_A = false;
                                this.error_latlon_T = false;
                            } else {
                                if (country_ID !== '66') {
                                    this.error_latlon_country = true;
                                } else {
                                    this.error_latlon_country = false;
                                }
                                if (data.provinceName == null || data.provinceName == 'null' || data.provinceName == '' || data.provinceName == ' ') {
                                    this.error_latlon_P = true;
                                } else {
                                    this.error_latlon_P = false;
                                }
                                if (data.amphurName == null || data.amphurName == 'null' || data.amphurName == '' || data.amphurName == ' ') {
                                    this.error_latlon_A = true;
                                } else {
                                    this.error_latlon_A = false;
                                }
                                if (data.tambonName == null || data.tambonName == 'null' || data.tambonName == '' || data.tambonName == ' ') {
                                    this.error_latlon_T = true;
                                } else {
                                    this.error_latlon_T = false;
                                }
                                this.idp_selectedProvince = null;
                                this.idp_selectedAmphur = null;
                                this.idp_selectedTambon = null;
                            }

                            // console.log("this.idp_selectedProvince",this.idp_selectedProvince)
                            // console.log("this.idp_selectedAmphur",this.idp_selectedAmphur)
                            // console.log("this.idp_selectedTambon",this.idp_selectedTambon)
                        } else {
                            this.idp_selectedProvince = null;
                            this.idp_selectedAmphur = null;
                            this.idp_selectedTambon = null;

                            this.error_latlon_country = false;
                            this.error_latlon_land = false;

                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        }
                    });
            } else {
                this.idp_selectedProvince = null;
                this.idp_selectedAmphur = null;
                this.idp_selectedTambon = null;

                this.error_latlon_country = false;
                this.error_latlon_land = false;

                this.error_latlon_P = false;
                this.error_latlon_A = false;
                this.error_latlon_T = false;
            }
        },

        async inputMap_PAT_latlon() {
            // console.log("<<<<<<<<<<<<<<<MMMMMMMMMMMMMM>>>>>>>>>>>>>>>")
            //   console.log("this.idp_selectedProvince",this.idp_selectedProvince)
            //   console.log("this.idp_selectedAmphur",this.idp_selectedAmphur)
            //   console.log("this.idp_selectedTambon",this.idp_selectedTambon)

            const url = 'https://service.deemap.com/service/gismis/boundary/geojson';

            let nnP = '';
            if (this.idp_selectedProvince) {
                this.sP.push(this.idp_selectedProvince.province_name);
                nnP = this.sP.length - 2;
            }

            let nnA = '';
            if (this.idp_selectedAmphur) {
                this.sA.push(this.idp_selectedAmphur.amphur_name);
                nnA = this.sA.length - 2;
            }

            if (this.idp_selectedProvince == null) {
                this.idp_lat = '';
                this.idp_lon = '';

                this.error_latlon_country = false;
                this.error_latlon_P = false;
                this.error_latlon_A = false;
                this.error_latlon_T = false;
            } else if (this.idp_selectedAmphur == null) {
                await this.axios
                    .post(url, {
                        key: '78e731027d8fd50ed642340b7c9a63b3',
                        topic: 'province',
                        type: 'point',
                        id: this.idp_selectedProvince.province_id
                    })
                    .then((response) => {
                        let getData = response.data.data;

                        const lon = getData.features[0].geometry.coordinates[0];
                        const lat = getData.features[0].geometry.coordinates[1];

                        this.idp_lat = lat;
                        this.idp_lon = lon;

                        this.error_latlon_country = false;
                        this.error_latlon_P = false;
                        this.error_latlon_A = false;
                        this.error_latlon_T = false;
                    });
            } else if (this.sP[nnP] !== this.idp_selectedProvince.province_name) {
                await this.axios
                    .post(url, {
                        key: '78e731027d8fd50ed642340b7c9a63b3',
                        topic: 'province',
                        type: 'point',
                        id: this.idp_selectedProvince.province_id
                    })
                    .then((response) => {
                        let getData = response.data.data;

                        const lon = getData.features[0].geometry.coordinates[0];
                        const lat = getData.features[0].geometry.coordinates[1];

                        this.idp_lat = lat;
                        this.idp_lon = lon;

                        this.error_latlon_country = false;
                        this.error_latlon_P = false;
                        this.error_latlon_A = false;
                        this.error_latlon_T = false;
                    });
            } else if (this.sA[nnA] !== this.idp_selectedAmphur.amphur_name) {
                await this.axios
                    .post(url, {
                        key: '78e731027d8fd50ed642340b7c9a63b3',
                        topic: 'amphoe',
                        type: 'point',
                        id: this.idp_selectedAmphur.amphur_id
                    })
                    .then((response) => {
                        let getData = response.data.data;

                        const lon = getData.features[0].geometry.coordinates[0];
                        const lat = getData.features[0].geometry.coordinates[1];

                        this.idp_lat = lat;
                        this.idp_lon = lon;

                        this.error_latlon_country = false;
                        this.error_latlon_P = false;
                        this.error_latlon_A = false;
                        this.error_latlon_T = false;
                    });
            } else {
                if (this.idp_selectedTambon) {
                    await this.axios
                        .post(url, {
                            key: '78e731027d8fd50ed642340b7c9a63b3',
                            topic: 'tambon',
                            type: 'point',
                            id: this.idp_selectedTambon.tambon_id
                        })
                        .then((response) => {
                            let getData = response.data.data;

                            const lon = getData.features[0].geometry.coordinates[0];
                            const lat = getData.features[0].geometry.coordinates[1];

                            this.idp_lat = lat;
                            this.idp_lon = lon;

                            this.error_latlon_country = false;
                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        });
                } else if (this.idp_selectedAmphur) {
                    await this.axios
                        .post(url, {
                            key: '78e731027d8fd50ed642340b7c9a63b3',
                            topic: 'amphoe',
                            type: 'point',
                            id: this.idp_selectedAmphur.amphur_id
                        })
                        .then((response) => {
                            let getData = response.data.data;

                            const lon = getData.features[0].geometry.coordinates[0];
                            const lat = getData.features[0].geometry.coordinates[1];

                            this.idp_lat = lat;
                            this.idp_lon = lon;

                            this.error_latlon_country = false;
                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        });
                } else if (this.idp_selectedProvince) {
                    await this.axios
                        .post(url, {
                            key: '78e731027d8fd50ed642340b7c9a63b3',
                            topic: 'province',
                            type: 'point',
                            id: this.idp_selectedProvince.province_id
                        })
                        .then((response) => {
                            let getData = response.data.data;

                            const lon = getData.features[0].geometry.coordinates[0];
                            const lat = getData.features[0].geometry.coordinates[1];

                            this.idp_lat = lat;
                            this.idp_lon = lon;

                            this.error_latlon_country = false;
                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        });
                } else {
                    this.idp_lat = '';
                    this.idp_lon = '';
                }
            }
        },
        //  Doe เพิ่มหมุด map V.2 6/9  จบ-->

        async confirmDelete() {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            if (this.deleteAt == 'disaster-table') {
                this.disaster_table = this.disaster_table.filter((val) => val !== this.disasterDelete);
                this.displayConfirmation = false;
                this.idp_disaster = this.disaster_table;
            } else if (this.deleteAt == 'organize') {
                this.displayConfirmation = false;
                this.organize_table = this.organize_table.filter((val) => val !== this.organizeDelete);
            } else {
                const userOrg = this.getUserOrganize(); //เช็คสิทธิ์
                const userId = this.getUsername();
                await this.axios
                    .post(`${this.$url_service}/initial/prevent?user=${userId}`, {
                        body: {
                            topic: 'delete-prevent',
                            id: this.temp
                        }
                    })
                    .then(() =>
                        // this.initialData()
                        this.searchDisasterPreventInfo()
                    );
                this.displayConfirmation = false;
                // this.$toast.add({
                //   severity: "success",
                //   summary: "ลบข้อมูลสำเร็จ",
                //   detail: "ข้อมูลระบบป้องกัน/บรรเทาสาธารณภัย",
                //   life: 3000,
                // });
                this.$fire({
                    type: 'success',
                    title: 'ลบข้อมูลสำเร็จ',
                    text: 'ข้อมูลระบบป้องกัน/บรรเทาสาธารณภัย',
                    timer: 3000,
                    confirmButtonColor: '#28B463'
                });
            }
        },

        async saveData() {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            this.iev_phone = [
                {
                    phone: this.contact_phone == '' ? '-' : this.contact_phone,
                    tel: this.contact_phone_office == '' ? '-' : this.contact_phone_office,
                    tel_ext: this.contact_phone_office_ext == '' ? '-' : this.contact_phone_office_ext
                }
            ];

            if ((this.idp_prevent_type == null) | (this.idp_prevent_name == '') || this.idp_organize.name == undefined) {
                if (this.idp_prevent_type == null) {
                    this.error_idp_prevent_type = true;
                }
                if (this.idp_prevent_name == '') {
                    this.error_idp_prevent_name = true;
                }
                if (this.idp_organize.name == undefined) {
                    this.error_idp_organize = true;
                }
            } else {
                if (this.contact_phone) {
                    if (this.contact_phone === '-') {
                        this.error_contact_phone = false;
                    } else if (this.contact_phone.length !== 12) {
                        this.error_contact_phone = true;
                    } else {
                        this.error_contact_phone = false;
                    }
                } else {
                    this.error_contact_phone = false;
                }
                if (this.contact_phone_office) {
                    if (this.contact_phone_office === '-') {
                        this.error_contact_phone_office = false;
                    } else if (this.contact_phone_office.length !== 11) {
                        this.error_contact_phone_office = true;
                    } else {
                        this.error_contact_phone_office = false;
                    }
                } else {
                    this.error_contact_phone_office = false;
                }

                if (!this.error_contact_phone && !this.error_contact_phone_office) {
                    if (this.selectedData == '') {
                        // โหลดเพิ่มแก้ไข 4/8
                        this.loadingCreate = true;
                        // โหลดเพิ่มแก้ไข 4/8 จบ

                        const userOrg = this.getUserOrganize(); //เช็คสิทธิ์
                        const userId = this.getUsername();
                        await this.axios
                            .post(`${this.$url_service}/initial/prevent?user=${userId}`, {
                                body: {
                                    topic: 'add-prevent',
                                    userOrg,
                                    type: this.idp_prevent_type.system_id,
                                    name: this.idp_prevent_name,
                                    organize: this.idp_organize.id,
                                    location: this.idp_location_detail,
                                    location_id: this.idp_selectedTambon,
                                    ct_name: this.idp_contact_name,
                                    ct_phone: this.idp_contact_phone,
                                    tel_detail: this.iev_phone,
                                    lat: this.idp_lat,
                                    lon: this.idp_lon,
                                    detail: this.idp_remark,
                                    disastertable: this.disaster_table
                                }
                            })
                            .then(() => {
                                // (this.initialData())
                                this.searchDisasterPreventInfo();

                                // this.$fire({
                                //       title: "เพิ่มข้อมูลสำเร็จ",
                                //       text: "ข้อมูลอุปกรณ์สำนักงาน",
                                //       type: "success",
                                //       timer: 3000,
                                //       confirmButtonColor: '#28B463',
                                //     });
                            });
                        // โหลดเพิ่มแก้ไข 5/8
                        this.loadingCreate = false;
                        // โหลดเพิ่มแก้ไข 5/8 จบ
                        // this.$toast.add({
                        //   severity: "success",
                        //   summary: "บันทึกข้อมูลสำเร็จ",
                        //   detail: "ข้อมูลระบบป้องกัน/บรรเทาสาธารณภัย",
                        //   life: 3000,
                        // });
                        this.$fire({
                            type: 'success',
                            title: 'เพิ่มข้อมูลสำเร็จ',
                            text: 'ข้อมูลระบบป้องกัน/บรรเทาสาธารณภัย',
                            timer: 3000,
                            confirmButtonColor: '#28B463'
                        });
                        // console.log("Save data");
                        this.tempFor_displayConfirmationCloseModal = 'add';
                        this.disasterPreventInfoModal = false;
                    } else {
                        // โหลดเพิ่มแก้ไข 6/8 จบ
                        this.loadingCreate = true;
                        // โหลดเพิ่มแก้ไข 6/8 จบ

                        const userOrg = this.getUserOrganize(); //เช็คสิทธิ์
                        const userId = this.getUsername();

                        await this.axios
                            .post(`${this.$url_service}/initial/prevent?user=${userId}`, {
                                body: {
                                    topic: 'edit-prevent',
                                    userOrg,
                                    id: this.temp,
                                    type: this.idp_prevent_type.system_id,
                                    name: this.idp_prevent_name,
                                    organize: this.idp_organize.id,
                                    location: this.idp_location_detail,
                                    location_id: this.idp_selectedTambon,
                                    ct_name: this.idp_contact_name,
                                    ct_phone: this.idp_contact_phone,
                                    tel_detail: this.iev_phone,
                                    lat: this.idp_lat,
                                    lon: this.idp_lon,
                                    detail: this.idp_remark,
                                    disastertable: this.disaster_table
                                }
                            })
                            .then(() =>
                                // (this.initialData())
                                this.searchDisasterPreventInfo()
                            );
                        // โหลดเพิ่มแก้ไข 7/8 จบ
                        this.loadingCreate = false;
                        // โหลดเพิ่มแก้ไข 7/8 จบ
                        // this.$toast.add({
                        //   severity: "success",
                        //   summary: "แก้ไขข้อมูลสำเร็จ",
                        //   detail: "ข้อมูลระบบป้องกัน/บรรเทาสาธารณภัย",
                        //   life: 3000,
                        // });
                        this.$fire({
                            type: 'success',
                            title: 'แก้ไขข้อมูลสำเร็จ',
                            text: 'ข้อมูลระบบป้องกัน/บรรเทาสาธารณภัย',
                            timer: 3000,
                            confirmButtonColor: '#28B463'
                        });
                        // console.log("Edit data");
                        this.disasterPreventInfoModal = false;
                    }
                }
            }
        },

        async editData(data) {
            if (!this.checkToken()) {
                return;
            }

            function toThaiDateFormat(dateString) {
                try {
                    // Split the date string by '/'
                    const [day, month, year] = dateString.split('/');

                    // Create a date object (months in JavaScript are 0-based, so subtract 1 from month)
                    const date = new Date(year, month - 1, day);

                    // Check if date is valid
                    if (isNaN(date.getTime())) {
                        return '-';
                    }

                    // Format options
                    const options = {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                    };

                    // Convert to Thai date
                    return date.toLocaleDateString('th-TH', options);
                } catch (error) {
                    return '-';
                }
            }
            // console.log('this.checkToken() = ', this.checkToken());

            this.header = this.$i18n.t('idp_modal_title_edit');
            await this.axios
                .post(`${this.$url_service}/initial/prevent`, {
                    body: {
                        topic: 'showone-prevent',
                        id: data
                    }
                })
                .then((response) => {
                    // console.log(response.data.data),
                    (this.selectedData = response.data.data),
                        (this.idp_prevent_name = response.data.data.prevent_name),
                        (this.idp_prevent_type = {
                            system_id: response.data.data.prevent_type_id,
                            system_name: response.data.data.system_name
                        }),
                        (this.idp_organize = {
                            id: response.data.data.prevent_organize,
                            name: response.data.data.organize_name
                        }),
                        (this.idp_location_detail = response.data.data.prevent_location),
                        (this.idp_contact_name = response.data.data.prevent_contact_name),
                        (this.idp_contact_phone = response.data.data.prevent_contact_phone),
                        (this.iev_phone = JSON.parse(response.data.data.tel_detail));
                    for (let index = 0; index < this.iev_phone.length; index++) {
                        const element = this.iev_phone[index];
                        this.contact_phone = element.phone;
                        this.contact_phone_office = element.tel;
                        this.contact_phone_office_ext = element.tel_ext;
                        // console.log("element.tel",element.tel)
                    }
                    (this.idp_lat = response.data.data.prevent_lat),
                        (this.idp_lon = response.data.data.prevent_lon),
                        (this.idp_remark = response.data.data.prevent_detail),
                        (this.idp_disaster = JSON.parse(response.data.data.disaster_id)),
                        (this.disaster_table = JSON.parse(response.data.data.disaster_id));

                    this.date_create_form =
                        toThaiDateFormat(response.data.data.date_create_ddmmyy) == null
                            ? '-'
                            : toThaiDateFormat(response.data.data.date_create_ddmmyy);
                    this.date_update_form =
                        toThaiDateFormat(response.data.data.date_update_ddmmyy) == null
                            ? '-'
                            : toThaiDateFormat(response.data.data.date_update_ddmmyy);

                    // Doe เพิ่มหมุด map V.2 7/9
                    if (this.idp_lat !== '' && this.idp_lat !== null && this.idp_lon !== '' && this.idp_lon !== null) {
                        this.inputMap_latlon();
                    } else {
                        this.inputMap_PAT_latlon();
                    }
                    // Doe เพิ่มหมุด map V.2 7/9  จบ
                });
        },

        clearData() {
            this.dropdownClearFilerValue += 1;
            this.multiSelectClearFilerValue += 1;
            //Edit data
            if (this.selectedData != '') {
                this.header = this.$i18n.t('idp_modal_title_add');
                this.temp = null;
                this.displayConfirmation = false;
                this.disasterPreventInfoModal = false;
                this.selectedData = '';
                this.setDefault();

                //Add data
            } else {
                this.temp = null;
                this.displayConfirmation = false;
                this.setDefault();
            }
        },

        setDefault() {
            this.tempFor_displayConfirmationCloseModal = '';
            this.idp_prevent_type = null;
            this.idp_prevent_name = '';
            this.idp_organize = {};
            this.idp_location_detail = '';
            this.idp_selectedProvince = null;
            this.idp_contact_name = '';
            this.idp_contact_phone = '';
            this.idp_lat = '';
            this.idp_lon = '';
            this.idp_remark = '';
            this.idp_disaster = null;
            this.disaster_table = [];
            this.error_idp_prevent_name = false;
            this.error_idp_organize = false;
            this.error_idp_prevent_type = false;

            this.contact_phone = '';
            this.contact_phone_office = '';
            this.contact_phone_office_ext = '';

            this.error_contact_phone = false;
            this.error_contact_phone_office = false;
            this.error_contact_phone_office_ext = false;

            this.error_latlon_country = false;
            this.error_latlon_land = false;
            this.error_latlon_P = false;
            this.error_latlon_A = false;
            this.error_latlon_T = false;

            this.date_create_form = '';
            this.date_update_form = '';
        },

        async clearSearchField() {
            this.prevent_name = '';
            this.preventTypeSelect = null;
            this.disasterTypeSelected = null;
            this.selectedProvince = null;
            this.selectedOrganize = {};
            this.prevent_code = '';
            this.location = '';

            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            this.text_Footer = false;

            this.organize_table = [];
            this.dropdownClearFilerValue += 1;
            // Doe ค้นหา
            this.filter = '';
            this.cloneTable = [];
            this.initialData();
        },

        // Doe โหลด โทรศัพท์
        async MobileClearSearchField() {
            // console.log("this.ms3333",this.ms)
            if (this.ms == true) {
                this.clearSearchField();
            } else {
                // console.log("25")
                this.prevent_name = '';
                this.preventTypeSelect = null;
                this.disasterTypeSelected = null;
                this.selectedProvince = null;
                this.selectedOrganize = {};
                this.prevent_code = '';
                this.location = '';

                this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
                this.text_Footer = false;

                this.organize_table = [];
                this.dropdownClearFilerValue += 1;
                this.filter = '';
                this.cloneTable = [];
            }
        },
        // Doe โหลด โทรศัพท์

        // Doe :   เพิ่ม มุดmap 4/4
        sendM(idp_lat, idp_lon) {
            let lat = idp_lat;
            let lon = idp_lon;
            this.latlon = { lat, lon };
            // console.log("send ",this.latlon)
        },
        sendM_PAT(tambon, amphur, province) {
            if (tambon) {
                this.PAT = tambon;
                // console.log("this.PAT=tambon",this.PAT)
            } else if (amphur) {
                this.PAT = amphur;
                // console.log("amphur",amphur)
            } else if (province) {
                this.PAT = province;
                // console.log("province",province)
            } else {
                this.PAT = {};
                // console.log("this.PAT={}",this.PAT)
            }
        },

        //  Doe เพิ่มหมุด map V.2 8/9  -->
        receiveM_PAT(data) {
            // console.log("data",data)
            const element = data.ADMIN_CODE;
            const country_ID = `${element[0]}${element[1]}`;
            const land_ID = `${element[2]}${element[3]}`;
            const province_ID = `${element[4]}${element[5]}`;
            const amphur_ID = `${element[4]}${element[5]}${element[6]}${element[7]}`;
            const tambon_ID = `${element[4]}${element[5]}${element[6]}${element[7]}${element[8]}${element[9]}`;

            if (country_ID == '66' && land_ID !== '00') {
                this.idp_selectedProvince = {
                    province_name: data.provinceName,
                    province_id: province_ID
                };
                this.idp_selectedAmphur = {
                    amphur_name: data.amphurName,
                    amphur_id: amphur_ID
                };
                this.idp_selectedTambon = {
                    tambon_name: data.tambonName,
                    tambon_id: tambon_ID
                };

                this.error_latlon_country = false;
                this.error_latlon_land = false;

                this.error_latlon_P = false;
                this.error_latlon_A = false;
                this.error_latlon_T = false;
            } else {
                if (country_ID !== '66') {
                    this.error_latlon_country = true;
                } else {
                    this.error_latlon_country = false;
                }
                if (data.provinceName == null || data.provinceName == 'null' || data.provinceName == '' || data.provinceName == ' ') {
                    this.error_latlon_P = true;
                } else {
                    this.error_latlon_P = false;
                }
                if (data.amphurName == null || data.amphurName == 'null' || data.amphurName == '' || data.amphurName == ' ') {
                    this.error_latlon_A = true;
                } else {
                    this.error_latlon_A = false;
                }
                if (data.tambonName == null || data.tambonName == 'null' || data.tambonName == '' || data.tambonName == ' ') {
                    this.error_latlon_T = true;
                } else {
                    this.error_latlon_T = false;
                }

                this.idp_selectedProvince = null;
                this.idp_selectedAmphur = null;
                this.idp_selectedTambon = null;
            }
        },
        //  Doe เพิ่มหมุด map V.2 8/9  จบ-->

        // Doe :   เพิ่ม มุดmap 4/4 จบ
        alertDisplay(temp, deleteAt) {
            this.$fire({
                title: 'ยืนยันการลบข้อมูล',
                text: 'คุณต้องการลบข้อมูลนี้ใช่หรือไม่ ?',

                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ตกลง',
                cancelButtonText: 'ยกเลิก'
            }).then((result) => {
                // console.log(temp)
                if (result.value) {
                    // console.log(temp)
                    this.confirmDelete(temp, deleteAt);
                }
            });
        },
        // Doe PDF เลือกได้  5/5
        EditPDF() {
            this.displayEditPDF = true;
            this.columnsSelectorDialog = this.columnsSelector;
        },
        SaveEditPDF() {
            if (this.columnsSelectorDialog.length <= 4) {
                this.PDF_minCellWidthVer = 120;
                this.PDF_FontHeaderVer = 15;
                this.PDF_FontBodyVer = 12;

                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 35 }
                };

                this.PDF_minCellWidthHor = 120;
                this.PDF_FontHeaderHor = 15;
                this.PDF_FontBodyHor = 12;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 35 }
                };
            } else {
                this.PDF_minCellWidthVer = 70;
                this.PDF_FontHeaderVer = 11;
                this.PDF_FontBodyVer = 8;
                this.PDF_BodySizeSelect = this.PDF_BodySize;

                this.PDF_minCellWidthHor = 70;
                this.PDF_FontHeaderHor = 15;
                this.PDF_FontBodyHor = 12;
                this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;
            }

            if (this.columnsSelectorDialog.length == 0) {
                this.columns_index = false;
                this.columns_prevent_name = false;
                this.columns_system_name = false;
                this.columns_disaster_details = false;
                this.columns_prevent_location = false;
                this.columns_prevent_contact_name = false;
                this.columns_prevent_contact_phone = false;

                this.columns_date_create = false;
                this.columns_date_update = false;

                this.columns_disabled = false;
            } else {
                this.columns_disabled = true;

                // console.log('this.columnsSelectorDialog =', this.columnsSelectorDialog);

                let getData = [];

                // ! จัดข้อมูล
                for (let index = 0; index < this.columnsSelectorDialog.length; index++) {
                    getData.push(this.columnsSelectorDialog[index].dataKey);
                }
                // console.log("getData",getData);

                // ! เช็คข้อมูล

                for (let index = 0; index < this.columnsSelectorDialog.length; index++) {
                    const element = this.columnsSelectorDialog[index].dataKey;

                    if (element == 'index') {
                        this.columns_index = true;
                    } else if (!getData.includes('index')) {
                        // console.log("getData.includes(index)",getData.includes("index"))
                        this.columns_index = false;
                    }

                    if (element == 'prevent_name') {
                        this.columns_prevent_name = true;
                    } else if (!getData.includes('prevent_name')) {
                        this.columns_prevent_name = false;
                    }

                    if (element == 'system_name') {
                        this.columns_system_name = true;
                    } else if (!getData.includes('system_name')) {
                        this.columns_system_name = false;
                    }

                    if (element == 'disaster_details') {
                        this.columns_disaster_details = true;
                    } else if (!getData.includes('disaster_details')) {
                        this.columns_disaster_details = false;
                    }

                    if (element == 'prevent_location') {
                        this.columns_prevent_location = true;
                    } else if (!getData.includes('prevent_location')) {
                        this.columns_prevent_location = false;
                    }

                    if (element == 'prevent_contact_name') {
                        this.columns_prevent_contact_name = true;
                    } else if (!getData.includes('prevent_contact_name')) {
                        this.columns_prevent_contact_name = false;
                    }

                    // if (element == "prevent_contact_phone") {
                    //   this.columns_prevent_contact_phone = true
                    // } else if(!getData.includes("prevent_contact_phone")){
                    //   this.columns_prevent_contact_phone = false
                    // }
                    if (element == 'text_tel_detail') {
                        this.columns_prevent_contact_phone = true;
                    } else if (!getData.includes('text_tel_detail')) {
                        this.columns_prevent_contact_phone = false;
                    }

                    if (element == 'date_create_ddmmyy') {
                        this.columns_date_create = true;
                    } else if (!getData.includes('date_create_ddmmyy')) {
                        this.columns_date_create = false;
                    }

                    if (element == 'date_update_ddmmyy') {
                        this.columns_date_update = true;
                    } else if (!getData.includes('date_update_ddmmyy')) {
                        this.columns_date_update = false;
                    }
                }
            }

            this.columnsSelector = this.columnsSelectorDialog;
            this.displayEditPDF = false;
            this.filter = '';
        },
        CloseEditPDF() {
            this.displayEditPDF = false;
        },
        ClearEditPDF() {
            this.columnsSelectorDialog = [];
        },
        SelectAllEditPDF() {
            this.columnsSelectorDialog = this.columns;
        }
        // Doe PDF เลือกได้  5/5 จบ
    }
};
</script>

<style scoped>
/*   Doe เพิ่มหมุด map V.2 9/9  --> */
.warningLATLON {
    color: rgb(225, 144, 13);
    font-size: 0.9rem;
}
/*   Doe เพิ่มหมุด map V.2 9/9  จบ--> */
.table_row {
    text-align: center;
}

@media screen and (min-width: 819px) and (max-width: 1200px) {
    #Search {
        width: 20rem;
    }
}
/* @media screen and (min-width: 538px){
      #Create{
      width: 146px;
    }
   
} */
#text_Foote {
    font-size: 1.2rem;
}
#Create {
    width: 149px;
}
#EX {
    width: 149px;
}
#PDF {
    width: 149px;
}
#TABLE_EDIT {
    width: 149px;
}
@media screen and (max-width: 818px) {
    #Search {
        width: 100%;
    }
}

@media screen and (max-width: 430px) {
    #Create {
        width: 50%;
    }
    #EX {
        width: 50%;
    }
    #PDF {
        width: 55%;
    }
    #TABLE_EDIT {
        width: 45%;
    }
    .EV_disasterOptions {
        width: 16.75rem;
        overflow-y: scroll;
    }
    .EV_disasterOptions::-webkit-scrollbar {
        width: 0;
        height: 1px;
    }

    .EV_disasterOptions::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    }

    .EV_disasterOptions::-webkit-scrollbar-thumb {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
    }
}

.p-field {
    margin-bottom: 0rem;
}
</style>

<style>
@keyframes p-progress-spinner-color {
    100%,
    0% {
        stroke: #75e9f4;
    }
    40% {
        stroke: #0057e7;
    }
    66% {
        stroke: #75e9f4;
    }
    80%,
    90% {
        stroke: #0057e7;
    }
}

.p-datatable-thead {
    border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
    border: 2px solid #d6d6d6;
}
</style>

<style scoped lang="scss">
:deep(.p-datatable-wrapper table) {
    border-left: 1px solid #d6d4d4;
    border-right: 1px solid #d6d4d4;
    border-collapse: separate;
    border-spacing: 0;
}
:deep(.p-datatable-scrollable-header-table) {
    background-color: #d6d4d4;
}
:deep(.p-datatable-wrapper) {
    max-height: 550px;
    overflow: auto;
}

:deep(.p-dialog) {
    @media screen and (max-width: 991px) {
        .p-dialog-content {
            overflow-y: auto;
        }
    }
}

.p-multiselect {
    min-width: 15rem;
}

.multiselect-custom {
    // Doe PDF เลือกได้
    width: 100%;
    .p-multiselect-label:not(.p-placeholder) {
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
    }

    .item {
        display: flex;
        align-items: center;
    }

    .item-value {
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 3px;
        display: inline-flex;
        margin-right: 0.5rem;
        background-color: var(--primary-color);
        color: var(--primary-color-text);
    }
}
</style>
